/*
 * Monte Seu Kit v3 — ARQUIVO GERADO. Não editar no tema.
 * Fontes: scripts/theme-build/monte-seu-kit/{src,vendor/codex-svg} (componente SVG Codex, commit 66d67ee).
 * Rebuild: node scripts/theme-build/monte-seu-kit/build.mjs
 * build 368462a51492
 */
// ---- vendor/codex-svg/component/model.mjs
const __m3 = (() => {
// Proportions from the original PDF fold paths; units are PDF points, not verified millimetres.
const CARTON = Object.freeze({ width: 56.693, height: 192.756, depth: 56.693 });
const BOXES = Object.freeze({
  6: Object.freeze({ capacity: 6, name: 'LES SIX', width: 354.968, height: 198.54, depth: 59.558, rim: 59.528 }),
  10: Object.freeze({ capacity: 10, name: 'LES ESSENTIELS', width: 589.606, height: 198.54, depth: 59.558, rim: 59.528 }),
});

function normalizeKit(input) {
  if (!BOXES[input?.kitSize]) throw new RangeError('kitSize deve ser 6 ou 10');
  if (!Array.isArray(input.selections)) throw new TypeError('selections deve ser uma lista ordenada');
  const ids = new Set();
  const selections = input.selections.map((unit) => {
    if (!unit || typeof unit.instanceId !== 'string' || !unit.instanceId.trim()) throw new TypeError('instanceId é obrigatório por unidade');
    if (ids.has(unit.instanceId)) throw new TypeError('instanceId deve ser único, inclusive em SKUs repetidos');
    if (typeof unit.sku !== 'string' || !unit.sku.trim()) throw new TypeError('sku é obrigatório');
    ids.add(unit.instanceId);
    return Object.freeze({ instanceId: unit.instanceId, sku: unit.sku, name: typeof unit.name === 'string' ? unit.name : unit.sku });
  });
  return Object.freeze({ kitSize: Number(input.kitSize), selections: Object.freeze(selections) });
}

function geometryFor(size) {
  const box = BOXES[size];
  if (!box) throw new RangeError('kitSize deve ser 6 ou 10');
  const base = 416, dx = 8.4, dy = -11.2, gap = 1.4;
  const margin = (box.width - size * CARTON.width - (size - 1) * gap) / 2;
  const cartonBase = base - 3.2;
  return Object.freeze({
    box, base, dx, dy, cartonBase,
    hinge: base - box.height + dy,
    lidTop: base - 2 * box.height + dy,
    // Compact frame: reserve only the small lift of a lid folded behind the minis.
    // Its width and baseline stay identical during opening and closing.
    viewBox: `-22 ${base - box.height + dy - 36} ${box.width + dx + 44} ${box.height - dy + 55}`,
    slots: Object.freeze(Array.from({ length: size }, (_, index) => Object.freeze({
      index, x: margin + index * (CARTON.width + gap), y: cartonBase - CARTON.height,
      width: CARTON.width, height: CARTON.height,
    }))),
  });
}

// A deterministic 2.5D fold: rear face lifts, passes edge-on, then covers the front.
// This is an editorial movement, not a full physical simulation of the cardboard.
function lidPose(size, progress) {
  const g = geometryFor(size), p = Math.max(0, Math.min(1, progress));
  const lift = Math.sin(Math.PI * p);
  return Object.freeze({
    x: g.dx * (1-p),
    y: g.hinge - g.dy*p - 28*lift,
    shear: -g.dx*.65*lift/g.box.height,
    scaleY: Math.abs(Math.cos(Math.PI*p)),
    inFront: p >= .5,
    edgeOpacity: Math.max(0, (p-.5)*2),
  });
}

function sceneFor(input) {
  const state = normalizeKit(input);
  const geometry = geometryFor(state.kitSize);
  return Object.freeze({ state, geometry, total: state.selections.length,
    complete: state.selections.length === state.kitSize,
    visible: Object.freeze(state.selections.slice(0, state.kitSize).map((unit, index) => Object.freeze({ ...unit, slot: geometry.slots[index] }))),
    overflow: Object.freeze(state.selections.slice(state.kitSize)),
  });
}

return Object.freeze({ CARTON, BOXES, normalizeKit, geometryFor, lidPose, sceneFor });
})();
// ---- vendor/codex-svg/component/renderer.mjs
const __m2 = (() => {
const { CARTON, sceneFor, lidPose } = __m3;

const NS = 'http://www.w3.org/2000/svg';
let nextSceneId = 0;
const node = (tag, attrs = {}, children = []) => {
  const el = document.createElementNS(NS, tag);
  Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
  el.append(...children);
  return el;
};
const polygon = (points, fill, attrs = {}) => node('polygon', { points: points.map(p => p.join(',')).join(' '), fill, ...attrs });

function createKitSvgPreview(mount, {
  catalog = [],
  boxAssets = {},
  unavailableSkus = [],
  onAssetError = () => {},
  onAssetResolved = () => {},
  onLidStateChange = () => {},
} = {}) {
  if (!mount || typeof mount.append !== 'function') throw new TypeError('mount deve aceitar elementos filhos');
  if (!Array.isArray(catalog)) throw new TypeError('catalog deve ser uma lista');
  const bySku = new Map();
  for (const item of catalog) {
    if (!item || typeof item.sku !== 'string' || !item.sku.trim()) throw new TypeError('catalog[].sku é obrigatório');
    if (bySku.has(item.sku)) throw new TypeError(`SKU duplicado no catálogo: ${item.sku}`);
    bySku.set(item.sku, item);
  }
  const prefix = `ls-kit-${++nextSceneId}`;
  const reduced = globalThis.matchMedia?.('(prefers-reduced-motion: reduce)') ?? {
    matches: false,
    addEventListener() {},
    removeEventListener() {},
  };
  const knownFailures = new Set();
  let unavailable = new Set(unavailableSkus), state = null, lastSize = null, destroyed = false;
  let geometry = null, lidProgress = 0, lidTarget = 0, lidFrame = null, lidTimer = null;
  const units = new Map();
  const svg = node('svg', { xmlns: NS, role: 'img', 'aria-labelledby': `${prefix}-title ${prefix}-desc`,
    preserveAspectRatio: 'xMidYMid meet', class: 'kit-svg', 'data-kit-svg': prefix,
    style: 'display:block;width:100%;height:auto;overflow:visible' });
  const title = node('title', { id: `${prefix}-title` });
  const desc = node('desc', { id: `${prefix}-desc` });
  const defs = node('defs');
  const gradient = (id, stops, attrs = {}) => node('linearGradient', { id: `${prefix}-${id}`, ...attrs },
    stops.map(([offset, color]) => node('stop', { offset, 'stop-color': color })));
  defs.append(
    gradient('paper', [['0%', '#fcfced'], ['100%', '#e6e6d5']], { x1: '0', y1: '0', x2: '0.15', y2: '1' }),
    gradient('back', [['0%', '#282c2d'], ['100%', '#14181a']], { x1: '0', y1: '0', x2: '0', y2: '1' }),
    gradient('front', [['0%', '#25292a'], ['100%', '#171b1d']], { x1: '0', y1: '0', x2: '0', y2: '1' }),
  );
  const rear = node('g', { 'data-layer': 'rear' });
  const products = node('g', { 'data-layer': 'cartons' });
  const front = node('g', { 'data-layer': 'front-rim' });
  const lid = node('g', { 'data-layer': 'lid', 'data-lid-side': 'rear' });
  const lidInterior = node('rect');
  const lidExterior = node('image', { preserveAspectRatio: 'none' });
  const lidOutline = node('rect', { fill:'none', stroke:'#242829', 'stroke-width':'.65' });
  const closedEdges = node('g', { 'data-layer': 'closed-edges', opacity:'0' });
  lid.append(lidInterior, lidExterior, lidOutline);
  lidExterior.addEventListener('error',()=>{lidExterior.setAttribute('opacity','0');svg.dataset.lidArtMissing='true';});
  lidExterior.addEventListener('load',()=>{lidExterior.setAttribute('opacity','1');delete svg.dataset.lidArtMissing;});
  svg.append(title, desc, defs, lid, rear, products, front, closedEdges);
  mount.append(svg);

  function drawBox(g) {
    const { box:b, base, dx, dy, hinge } = g;
    const w = b.width, rimTop = base-b.rim;
    geometry = g;
    rear.replaceChildren(); front.replaceChildren();
    rear.append(node('ellipse', { cx:w/2+dx/2, cy:base+7, rx:w/2+9, ry:6, fill:'#161b1f', opacity:'.08' }));
    for(const face of [lidInterior,lidExterior,lidOutline]) {
      face.setAttribute('width',w);face.setAttribute('height',b.height);
    }
    const boxAsset = boxAssets?.[b.capacity];
    const configuredLid = typeof boxAsset === 'string' ? boxAsset : boxAsset?.lidExterior;
    if (typeof configuredLid === 'string' && configuredLid.trim()) {
      lidExterior.setAttribute('href', configuredLid);
      lidExterior.setAttribute('opacity', '1');
      delete svg.dataset.lidArtMissing;
    } else {
      lidExterior.removeAttribute('href');
      lidExterior.setAttribute('opacity', '0');
      svg.dataset.lidArtMissing = 'true';
    }
    closedEdges.replaceChildren(
      polygon([[0,base-b.height],[w,base-b.height],[w+dx,hinge],[dx,hinge]],'#1a1f21'),
      polygon([[w,base],[w+dx,base+dy],[w+dx,hinge],[w,base-b.height]],'#101517'));
    rear.append(
      node('rect',{x:dx,y:hinge,width:w,height:b.height,fill:`url(#${prefix}-back)`}),
      node('path',{d:`M ${dx} ${hinge} H ${w+dx}`,stroke:'#75776b','stroke-width':'.7',opacity:'.5'}),
      polygon([[0,base],[w,base],[w+dx,base+dy],[dx,base+dy]],'#191d1f'),
      polygon([[0,base],[dx,base+dy],[dx,rimTop+dy],[0,rimTop]],'#363a39'),
      node('path',{d:`M ${dx} ${hinge+1} V ${base+dy}`,stroke:'#050909','stroke-width':'2',opacity:'.16'}));
    // The visible side wall must occlude the last carton's lower side too.
    // A folded paper edge has no broad horizontal shelf above the front panel.
    front.append(polygon([[w,base],[w+dx,base+dy],[w+dx,rimTop+dy],[w,rimTop]],'#101517',{'data-layer':'right-wall'}),
      node('rect',{x:0,y:rimTop,width:w,height:b.rim,fill:`url(#${prefix}-front)`}),
      node('path',{d:`M 0 ${base} H ${w} L ${w+dx} ${base+dy}`,stroke:'#0f1415','stroke-width':'.6'}));
    svg.setAttribute('viewBox', g.viewBox);
    svg.dataset.kitSize = String(b.capacity);
    drawLid();
  }

  function describeLid(phase) {
    svg.dataset.lidState = phase;
    if(state) {
      const b=geometry.box;
      title.textContent=`${b.name}: ${Math.min(state.selections.length,state.kitSize)} de ${state.kitSize} minis na caixa`;
      desc.textContent=(phase==='closed'?'Caixa fechada com a arte externa original.':phase==='open'?'Tampa dobrada atrás dos minis. Minis em pé, em uma fileira.':'Tampa em movimento entre a parte traseira e a frente da caixa.')
        + (state.selections.length>state.kitSize?` ${state.selections.length-state.kitSize} unidades excedentes preservadas na lista.`:'');
    }
    onLidStateChange(phase);
  }
  function drawLid() {
    if(!geometry)return;
    const pose=lidPose(geometry.box.capacity,lidProgress);
    lid.setAttribute('transform',`matrix(1 0 ${pose.shear} ${pose.scaleY} ${pose.x} ${pose.y})`);
    lid.dataset.lidSide=pose.inFront?'front':'rear';
    lid.dataset.progress=lidProgress.toFixed(4);
    lidInterior.setAttribute('fill',pose.inFront?(geometry.box.capacity===6?'#161b1f':'#fbfcef'):`url(#${prefix}-paper)`);
    lidExterior.setAttribute('visibility',pose.inFront?'visible':'hidden');
    closedEdges.setAttribute('opacity',pose.edgeOpacity);
    if(pose.inFront){if(svg.lastElementChild!==lid)svg.append(lid);}
    else if(lid.nextElementSibling!==rear)svg.insertBefore(lid,rear);
  }
  function cancelLidMotion() {
    cancelAnimationFrame(lidFrame);clearTimeout(lidTimer);lidFrame=null;lidTimer=null;
  }
  function setClosed(closed, {animate=true}={}) {
    if(destroyed)throw new Error('Preview descartado');
    if(!geometry)throw new Error('Defina o kit antes de movimentar a tampa');
    const target=closed?1:0;
    if(target===lidTarget && (lidProgress===target || (animate && !reduced.matches && lidFrame!==null)))return;
    cancelLidMotion();lidTarget=target;
    const finish=()=>{cancelLidMotion();lidProgress=lidTarget;drawLid();describeLid(lidTarget?'closed':'open');};
    if(!animate || reduced.matches || lidProgress===target){finish();return;}
    const from=lidProgress, started=performance.now(), duration=1150*Math.abs(target-from);
    describeLid(target?'closing':'opening');
    const tick=(now)=>{
      const t=Math.min(1,(now-started)/duration), eased=t*t*(3-2*t);
      lidProgress=from+(target-from)*eased;drawLid();
      if(t===1)finish();else lidFrame=requestAnimationFrame(tick);
    };
    lidFrame=requestAnimationFrame(tick);
    lidTimer=setTimeout(finish,duration+30);
  }

  function stop(record) {
    clearTimeout(record.timer);
    record.timer = null;
    if (record.animation) {
      record.animation.onfinish = null;
      record.animation.cancel();
      record.animation = null;
    }
  }
  function remove(record) { stop(record); record.outer.remove(); units.delete(record.id); }
  const failureKey = (sku, face = '') => `${sku}\u0000${face}`;
  const hasKnownFailure = sku => [...knownFailures].some(key => key.startsWith(`${sku}\u0000`));
  function reportFailure(sku, face, reason) {
    const key = failureKey(sku, face);
    if (!knownFailures.has(key)) {
      knownFailures.add(key);
      onAssetError(sku, Object.freeze({ sku, face: face || undefined, reason }));
    }
    for (const r of units.values()) if (r.sku === sku) applyAvailability(r);
  }
  function reportResolved(sku, face) {
    const key = failureKey(sku, face);
    if (!knownFailures.delete(key)) return;
    onAssetResolved(sku, Object.freeze({ sku, face: face || undefined }));
    for (const r of units.values()) if (r.sku === sku) applyAvailability(r);
  }
  function applyAvailability(record) {
    const hidden = unavailable.has(record.sku);
    const missing = hidden || hasKnownFailure(record.sku) || !bySku.has(record.sku);
    record.textures.setAttribute('visibility', hidden ? 'hidden' : 'visible');
    record.outer.dataset.assetMissing = String(missing);
  }
  function makeUnit(unit) {
    const { width:w, height:h, depth:d } = CARTON;
    const dx=8, dy=-10.7;
    const outer=node('g',{'data-instance-id':unit.instanceId,'data-sku':unit.sku});
    const animated=node('g',{'data-motion':'carton',style:'transform-box:fill-box;transform-origin:50% 100%'});
    const textures=node('g');
    animated.append(
      polygon([[0,0],[w,0],[w+dx,dy],[dx,dy]],'#1a2021'),
      polygon([[w,0],[w+dx,dy],[w+dx,h+dy],[w,h]],'#e5e6d6'),
      node('rect',{x:0,y:0,width:w,height:h,fill:'#f8f9e9'}));
    const art=bySku.get(unit.sku)?.faces;
    let record;
    if (art) {
      const image=(face,attrs)=>{
        const url = art[face];
        if (typeof url !== 'string' || !url.trim()) {
          queueMicrotask(()=>{if(!destroyed && units.get(unit.instanceId)===record)reportFailure(unit.sku,face,'missing-url');});
          return null;
        }
        const im=node('image',{href:url,preserveAspectRatio:'none',...attrs});
        // A replaced carton's cancelled request must not mark its surviving SKU
        // unavailable after a kit-size change or a dialog being discarded.
        im.addEventListener('error',()=>{
          im.setAttribute('visibility','hidden');
          if(!destroyed && im.isConnected && units.get(unit.instanceId)===record)reportFailure(unit.sku,face,'load-error');
        });
        im.addEventListener('load',()=>{
          im.setAttribute('visibility','visible');
          if(!destroyed && im.isConnected && units.get(unit.instanceId)===record)reportResolved(unit.sku,face);
        });
        return im;
      };
      textures.append(...[
        image('front',{width:w,height:h}),
        image('side',{width:d,height:h,transform:`matrix(${dx/d} ${dy/d} 0 1 ${w} 0)`}),
        image('top',{width:w,height:d,transform:`matrix(1 0 ${-dx/d} ${-dy/d} ${dx} ${dy})`}),
      ].filter(Boolean));
    }
    animated.append(textures,
      polygon([[w,0],[w+dx,dy],[w+dx,h+dy],[w,h]],'#101716',{opacity:'.1'}),
      node('path',{d:`M 0 0 H ${w} V ${h}`,fill:'none',stroke:'#85877a','stroke-width':'.35',opacity:'.4'}));
    outer.append(animated);
    record={id:unit.instanceId,sku:unit.sku,outer,animated,textures,animation:null,timer:null,exiting:false};
    applyAvailability(record);
    if (!art) queueMicrotask(()=>{
      if(!destroyed && units.get(unit.instanceId)===record)reportFailure(unit.sku,undefined,'unknown-sku');
    });
    return record;
  }
  function enter(record) {
    if(reduced.matches || typeof record.animated.animate!=='function')return;
    record.animation=record.animated.animate([
      {transform:`translateY(${-CARTON.height*.06}px)`,opacity:0},
      {transform:'translateY(0)',opacity:1},
    ],{duration:280,easing:'cubic-bezier(.2,.7,.3,1)'});
    record.animation.onfinish=()=>stop(record);
    // Background/hidden panels can suspend the animation timeline. Settle the
    // transient node state on wall time too, so revealing a drawer never replays it.
    record.timer=setTimeout(()=>stop(record),280);
  }
  function exit(record) {
    stop(record);record.exiting=true;record.outer.dataset.exiting='true';
    if(reduced.matches || typeof record.animated.animate!=='function'){remove(record);return;}
    record.animation=record.animated.animate([
      {transform:'translateY(0)',opacity:1},
      {transform:`translateY(${-CARTON.height*.03}px)`,opacity:0},
    ],{duration:160,easing:'ease-out'});
    record.animation.onfinish=()=>remove(record);
    record.timer=setTimeout(()=>remove(record),160);
  }

  function setKit(input) {
    if(destroyed)throw new Error('Preview descartado');
    const scene=sceneFor(input); // Validate before changing the accepted scene.
    const changedSize=lastSize!==scene.state.kitSize;
    const compositionChanged=changedSize || state?.selections.length!==scene.state.selections.length
      || scene.state.selections.some((u,i)=>u.instanceId!==state?.selections[i]?.instanceId || u.sku!==state?.selections[i]?.sku);
    if(compositionChanged){cancelLidMotion();lidProgress=0;lidTarget=0;}
    const beforeIds=state?.selections.map(u=>u.instanceId)??[];
    const nextIds=scene.visible.map(u=>u.instanceId);
    const wasPresent=new Set(beforeIds);
    if(changedSize){for(const r of units.values())remove(r);drawBox(scene.geometry);}
    // New input is authoritative. Do not retain a queue of obsolete exiting nodes.
    for(const r of [...units.values()]){
      if(r.exiting)remove(r);
      else if(!nextIds.includes(r.id))exit(r);
    }
    for(const unit of scene.visible){
      let record=units.get(unit.instanceId);
      if(record && record.sku!==unit.sku){remove(record);record=null;}
      const fresh=!record;
      if(fresh){record=makeUnit(unit);units.set(unit.instanceId,record);}
      record.outer.setAttribute('transform',`translate(${unit.slot.x} ${unit.slot.y})`);
      record.outer.dataset.slot=unit.slot.index;
      products.append(record.outer); // Enforce ordered paint without recreating surviving units.
      if(fresh && !wasPresent.has(unit.instanceId))enter(record);
    }
    lastSize=scene.state.kitSize;state=scene.state;
    drawLid();
    describeLid(lidFrame!==null?(lidTarget?'closing':'opening'):(lidTarget?'closed':'open'));
    svg.dataset.complete=String(scene.complete);
    svg.dataset.overflow=String(scene.overflow.length);
  }

  function setUnavailableSkus(skus) {
    if(destroyed)throw new Error('Preview descartado');
    const previous=unavailable; unavailable=new Set(skus);
    for(const sku of previous)if(!unavailable.has(sku)&&!hasKnownFailure(sku))onAssetResolved(sku,Object.freeze({sku,reason:'available'}));
    for(const sku of unavailable)if(!previous.has(sku))onAssetError(sku,Object.freeze({sku,reason:'unavailable'}));
    for(const r of units.values())applyAvailability(r);
  }
  function settleMotion(){if(!reduced.matches)return;for(const r of [...units.values()]){if(r.exiting)remove(r);else stop(r);}cancelLidMotion();lidProgress=lidTarget;drawLid();describeLid(lidTarget?'closed':'open');}
  reduced.addEventListener('change',settleMotion);
  queueMicrotask(()=>{if(!destroyed)for(const sku of unavailable)onAssetError(sku,Object.freeze({sku,reason:'unavailable'}));});
  return Object.freeze({setKit,setClosed,setUnavailableSkus,getKit:()=>state,
    destroy(){if(destroyed)return;destroyed=true;cancelLidMotion();reduced.removeEventListener('change',settleMotion);for(const r of [...units.values()])remove(r);svg.remove();},
  });
}

return Object.freeze({ createKitSvgPreview });
})();
// ---- vendor/codex-svg/component/index.mjs
const __m1 = (() => {

return Object.freeze({ createKitSvgPreview: __m2.createKitSvgPreview, BOXES: __m3.BOXES, CARTON: __m3.CARTON, geometryFor: __m3.geometryFor, lidPose: __m3.lidPose, normalizeKit: __m3.normalizeKit, sceneFor: __m3.sceneFor });
})();
// ---- vendor/codex-svg/catalog-data.mjs
const __m4 = (() => {
// Generated by scripts/build-catalog.mjs from source-map.json. Visual metadata only.
const CATALOG_DATA = [
  {
    "sku": "SOUFFLE-DE-MATCHA-5ML",
    "name": "Soufflé de Matcha",
    "family": "Soufflé",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "matcha-front.svg",
      "top": "matcha-top.svg",
      "side": "matcha-side.svg"
    }
  },
  {
    "sku": "BRISE-DE-FREESIA-5ML",
    "name": "Brise de Freesia",
    "family": "Brise",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "freesia-front.svg",
      "top": "freesia-top.svg",
      "side": "freesia-side.svg"
    }
  },
  {
    "sku": "DOUCEUR-DE-LITCHI-5ML",
    "name": "Douceur de Litchi",
    "family": "Douceur",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "litchi-front.svg",
      "top": "litchi-top.svg",
      "side": "litchi-side.svg"
    }
  },
  {
    "sku": "BRISE-DE-BERGAMOTE-5ML",
    "name": "Brise de Bergamote",
    "family": "Brise",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "bergamote-front.svg",
      "top": "bergamote-top.svg",
      "side": "bergamote-side.svg"
    }
  },
  {
    "sku": "BRISE-DE-LIMA-5ML",
    "name": "Brise de Lima",
    "family": "Brise",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "lima-front.svg",
      "top": "lima-top.svg",
      "side": "lima-side.svg"
    }
  },
  {
    "sku": "BRISE-DE-MURES-5ML",
    "name": "Brise de Mûres",
    "family": "Brise",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "mures-front.svg",
      "top": "mures-top.svg",
      "side": "mures-side.svg"
    }
  },
  {
    "sku": "BRUME-DE-BAIN-5ML",
    "name": "Brume de Bain",
    "family": "Brume",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "bain-front.svg",
      "top": "bain-top.svg",
      "side": "bain-side.svg"
    }
  },
  {
    "sku": "BRUME-DE-PATCHOULI-5ML",
    "name": "Brume de Patchouli",
    "family": "Brume",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "patchouli-front.svg",
      "top": "patchouli-top.svg",
      "side": "patchouli-side.svg"
    }
  },
  {
    "sku": "DOUCEUR-DE-NECTAR-5ML",
    "name": "Douceur de Nectar",
    "family": "Douceur",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "nectar-front.svg",
      "top": "nectar-top.svg",
      "side": "nectar-side.svg"
    }
  },
  {
    "sku": "SOUFFLE-DE-SANTAL-5ML",
    "name": "Soufflé de Santal",
    "family": "Soufflé",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "santal-front.svg",
      "top": "santal-top.svg",
      "side": "santal-side.svg"
    }
  },
  {
    "sku": "SORBET-GINGEMBRE-5ML",
    "name": "Sorbet Gingembre",
    "family": "Sorbets",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "gingembre-front.svg",
      "top": "gingembre-top.svg",
      "side": "gingembre-side.svg"
    }
  },
  {
    "sku": "SORBET-MELON-5ML",
    "name": "Sorbet Melon",
    "family": "Sorbets",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "melon-front.svg",
      "top": "melon-top.svg",
      "side": "melon-side.svg"
    }
  },
  {
    "sku": "SORBET-CAMOMILLE-ANANAS-5ML",
    "name": "Sorbet Camomille & Ananas",
    "family": "Sorbets",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "ananas-front.svg",
      "top": "ananas-top.svg",
      "side": "ananas-side.svg"
    }
  },
  {
    "sku": "SORBET-CONCOMBRE-SEL-5ML",
    "name": "Sorbet Concombre & Fleur de Sel",
    "family": "Sorbets",
    "visualSource": "official-pdf",
    "visualLimitations": [],
    "faces": {
      "front": "concombre-front.svg",
      "top": "concombre-top.svg",
      "side": "concombre-side.svg"
    }
  },
  {
    "sku": "BRUME-DE-BAIN-VERTE-5ML",
    "name": "Brume de Bain Verte",
    "family": "Brume",
    "visualSource": "official-packshot",
    "visualLimitations": [
      "raster-front",
      "shared-official-top",
      "neutral-side"
    ],
    "faces": {
      "front": "bain-verte-front.svg",
      "top": "matcha-top.svg",
      "side": "neutral-side.svg"
    }
  },
  {
    "sku": "LINGE-DE-BEBE-5ML",
    "name": "Linge de Bébé",
    "family": "Les Linges",
    "visualSource": "official-packshot",
    "visualLimitations": [
      "raster-front",
      "shared-official-top",
      "neutral-side"
    ],
    "faces": {
      "front": "linge-bebe-front.svg",
      "top": "matcha-top.svg",
      "side": "neutral-side.svg"
    }
  },
  {
    "sku": "LINGE-AU-SOLEIL-5ML",
    "name": "Linge au Soleil",
    "family": "Les Linges",
    "visualSource": "official-packshot",
    "visualLimitations": [
      "raster-front",
      "shared-official-top",
      "neutral-side"
    ],
    "faces": {
      "front": "linge-soleil-front.svg",
      "top": "matcha-top.svg",
      "side": "neutral-side.svg"
    }
  },
  {
    "sku": "BAIN-DE-LINGE-5ML",
    "name": "Bain de Linge",
    "family": "Les Linges",
    "visualSource": "official-packshot",
    "visualLimitations": [
      "raster-front",
      "shared-official-top",
      "neutral-side"
    ],
    "faces": {
      "front": "bain-linge-front.svg",
      "top": "matcha-top.svg",
      "side": "neutral-side.svg"
    }
  },
  {
    "sku": "LINGE-A-LA-VAPEUR-5ML",
    "name": "Linge à la Vapeur",
    "family": "Les Linges",
    "visualSource": "official-packshot",
    "visualLimitations": [
      "raster-front",
      "shared-official-top",
      "neutral-side"
    ],
    "faces": {
      "front": "linge-vapeur-front.svg",
      "top": "matcha-top.svg",
      "side": "neutral-side.svg"
    }
  },
  {
    "sku": "LINGE-LAVE-5ML",
    "name": "Linge Lavé",
    "family": "Les Linges",
    "visualSource": "official-packshot",
    "visualLimitations": [
      "raster-front",
      "shared-official-top",
      "neutral-side"
    ],
    "faces": {
      "front": "linge-lave-front.svg",
      "top": "matcha-top.svg",
      "side": "neutral-side.svg"
    }
  },
  {
    "sku": "LINGE-DE-CACHEMIRE-5ML",
    "name": "Linge de Cachemire",
    "family": "Les Linges",
    "visualSource": "official-packshot",
    "visualLimitations": [
      "raster-front",
      "shared-official-top",
      "neutral-side"
    ],
    "faces": {
      "front": "linge-cachemire-front.svg",
      "top": "matcha-top.svg",
      "side": "neutral-side.svg"
    }
  }
];

const BOX_ASSET_FILES = Object.freeze({
  6: Object.freeze({ lidExterior: 'k6-lid-exterior.svg' }),
  10: Object.freeze({ lidExterior: 'k10-lid-exterior.svg' }),
});

// Supply a filename-to-CDN-URL resolver when integrating into the real theme.
function createVisualCatalog(resolveAsset = file => new URL('./assets/' + file, import.meta.url).href) {
  return CATALOG_DATA.map(item => ({ ...item, faces: Object.fromEntries(Object.entries(item.faces).map(([face, file]) => [face, resolveAsset(file)])) }));
}
function createBoxAssets(resolveAsset = file => new URL('./assets/' + file, import.meta.url).href) {
  return Object.fromEntries(Object.entries(BOX_ASSET_FILES).map(([size, faces]) => [size, { lidExterior: resolveAsset(faces.lidExterior) }]));
}

return Object.freeze({ CATALOG_DATA, BOX_ASSET_FILES, createVisualCatalog, createBoxAssets });
})();
// ---- src/state.mjs
const __m5 = (() => {
// Estado único do builder Monte Seu Kit (kit de 6 ou 10 minis; caixas LES SIX / LES ESSENTIELS na logística).
// Puro e imutável: sem DOM, sem fetch, sem storage. Testado por node --test.
//
// Unidade = { instanceId, variantId }. variantId é o id da variante da PICK (vem do Liquid).
// state.units  = o kit ATIVO, na ordem da caixa (repetições são unidades distintas). É o que vai para a caixa,
//                para o progresso, para o preço e para o carrinho.
// state.stash  = unidades GUARDADAS: ao voltar de 10 para 6, as que passam das 6 primeiras saem do kit ativo
//                e ficam aqui, na mesma ordem. Não contam em nada. Voltar para 10 as devolve ao fim do kit.
// Preço/estoque/disponibilidade NUNCA ficam no estado: vêm do catálogo comercial lido do DOM.

const KIT_SIZES = Object.freeze([6, 10]);
// Nome exibido na vitrine/carrinho. LES SIX / LES ESSENTIELS são produtos fixos e NÃO nomeiam o kit montado
// (a arte impressa da caixa continua a mesma; a separação logística tem lista própria).
const KIT_LABELS = Object.freeze({ 6: 'Monte Seu Kit · 6 minis', 10: 'Monte Seu Kit · 10 minis' });
const STORAGE_VERSION = 3;
const STORAGE_PREFIX = 'lsn:monte-seu-kit:v3';
const LEGACY_STORAGE_KEYS = Object.freeze(['lsn:monte-seu-kit:v2:mini:6']);
const TTL_MS = 24 * 60 * 60 * 1000;

const freezeUnits = (units) => Object.freeze(units.map((u) => Object.freeze({ instanceId: u.instanceId, variantId: u.variantId })));
const make = (sizes, size, units, stash) => Object.freeze({ sizes, size, units: freezeUnits(units), stash: freezeUnits(stash) });
const biggerThan = (state, n) => state.sizes.find((z) => z > n);

function parseSizes(raw) {
  const list = String(raw ?? '6').split(',').map((s) => parseInt(s.trim(), 10)).filter((n) => KIT_SIZES.includes(n));
  const uniq = [...new Set(list)].sort((a, b) => a - b);
  return Object.freeze(uniq.length ? uniq : [6]);
}

function storageKey(sizes) {
  return `${STORAGE_PREFIX}:${Math.max(...sizes)}`;
}

function createKitState({ sizes = [6], size } = {}) {
  const s = parseSizes(sizes.join(','));
  const chosen = s.includes(Number(size)) ? Number(size) : s[0];
  return make(s, chosen, [], []);
}

/** Quantidade daquele mini no kit ATIVO (é o que o card mostra). */
function countOf(state, variantId) {
  const id = String(variantId);
  return state.units.reduce((n, u) => n + (u.variantId === id ? 1 : 0), 0);
}

/** Quantidade no kit ativo + guardadas (usada para o teto de estoque). */
function countAllOf(state, variantId) {
  const id = String(variantId);
  return countOf(state, id) + state.stash.reduce((n, u) => n + (u.variantId === id ? 1 : 0), 0);
}

function capOf(product) {
  const cap = Number(product?.cap);
  return Number.isFinite(cap) ? Math.max(0, Math.min(Math.max(...KIT_SIZES), Math.floor(cap))) : Math.max(...KIT_SIZES);
}

/**
 * products: Map<variantId, { available:boolean, cap:number, commercial?:boolean, kitPrice?:number, avulsoPrice?:number }>
 * Retorna { state, ok, reason, switchedTo, fullSize }.
 *   reason: 'unknown' | 'unavailable' | 'cap' | 'full'
 *   switchedTo: tamanho novo quando a adição trocou o kit automaticamente (6 cheio + 1 => 10, com as guardadas de volta)
 *   fullSize: tamanho da caixa que ficou cheia (para a dica "Caixa de N completa")
 */
function addUnit(state, variantId, products, newId) {
  const id = String(variantId);
  const p = products.get(id);
  if (!p) return { state, ok: false, reason: 'unknown' };
  if (!p.available) return { state, ok: false, reason: 'unavailable' };
  if (countAllOf(state, id) >= capOf(p)) return { state, ok: false, reason: 'cap' };
  const fresh = () => {
    const instanceId = newId();
    const taken = [...state.units, ...state.stash].some((u) => u.instanceId === instanceId);
    if (typeof instanceId !== 'string' || !instanceId || taken) throw new TypeError('instanceId novo inválido ou repetido');
    return { instanceId, variantId: id };
  };
  if (state.units.length < state.size) {
    return { state: make(state.sizes, state.size, [...state.units, fresh()], state.stash), ok: true, reason: null };
  }
  // Caixa ativa cheia: se existe caixa maior, troca para ela, devolve as guardadas e aceita a nova.
  const bigger = biggerThan(state, state.size);
  if (!bigger) return { state, ok: false, reason: 'full', fullSize: state.size };
  const merged = [...state.units, ...state.stash];
  if (merged.length >= bigger) return { state, ok: false, reason: 'full', fullSize: bigger };
  return { state: make(state.sizes, bigger, [...merged, fresh()], []), ok: true, reason: null, switchedTo: bigger };
}

/** Remove uma unidade do kit ATIVO (as guardadas não são tocadas). */
function removeUnit(state, instanceId) {
  const next = state.units.filter((u) => u.instanceId !== instanceId);
  return next.length === state.units.length ? state : make(state.sizes, state.size, next, state.stash);
}

/** Remove a ÚLTIMA unidade daquele mini no kit ativo (o "−" do card), preservando a ordem das demais. */
function removeLastOf(state, variantId) {
  const id = String(variantId);
  for (let i = state.units.length - 1; i >= 0; i -= 1) {
    if (state.units[i].variantId === id) return make(state.sizes, state.size, state.units.filter((_, j) => j !== i), state.stash);
  }
  return state;
}

function clearUnits(state) {
  return state.units.length || state.stash.length ? make(state.sizes, state.size, [], []) : state;
}

/**
 * Troca de tamanho sem descartar nada.
 *   10 -> 6: as 6 primeiras (ordem da caixa) formam o kit; as demais vão para as guardadas.
 *   6 -> 10: as guardadas voltam ao fim do kit, na mesma ordem.
 */
function setSize(state, size) {
  const n = Number(size);
  if (!state.sizes.includes(n) || n === state.size) return state;
  const all = [...state.units, ...state.stash];
  return make(state.sizes, n, all.slice(0, n), all.slice(n));
}

function summarize(state, products = new Map()) {
  const total = state.units.length;
  let kitCents = 0;
  let avulsoCents = 0;
  for (const u of state.units) {
    const p = products.get(u.variantId);
    kitCents += Number(p?.kitPrice) || 0;
    avulsoCents += Number(p?.avulsoPrice) || Number(p?.kitPrice) || 0;
  }
  return Object.freeze({
    size: state.size,
    label: KIT_LABELS[state.size],
    total,
    remaining: Math.max(0, state.size - total),
    stashCount: state.stash.length,
    complete: total === state.size,
    kitCents,
    avulsoCents,
    savingsCents: Math.max(0, avulsoCents - kitCents),
    previewCount: state.units.filter((u) => products.get(u.variantId)?.commercial === false).length,
  });
}

/** Kit ativo exatamente no tamanho escolhido, só com picks comerciais disponíveis e dentro do teto. */
function canSubmit(state, products = new Map()) {
  if (!state.sizes.includes(state.size) || state.units.length !== state.size) return false;
  const counts = new Map();
  for (const u of state.units) counts.set(u.variantId, (counts.get(u.variantId) || 0) + 1);
  for (const [id, qty] of counts) {
    const p = products.get(id);
    if (!p || !p.available || p.commercial === false || !/^\d+$/.test(id) || qty > capOf(p)) return false;
  }
  return true;
}

const plural = (n, one, many) => (n === 1 ? one : many);

/** Dica do CONFIRMAR com o kit incompleto. null quando o kit está completo. */
function missingText(state, unit = 'mini') {
  const s = summarize(state);
  if (s.remaining === 0) return null;
  const n = (k) => `${k} ${plural(k, unit, `${unit}s`)}`;
  return s.total === 0 ? `Escolha ${n(state.size)} para o kit.` : `Faltam ${n(s.remaining)}.`;
}

function fullText(size) {
  return `Caixa de ${size} completa`;
}

/**
 * Payload do POST /cart/add.js — contrato inalterado:
 * 1 item por variante distinta do kit ATIVO (quantity somada, ordem de 1ª aparição) + properties _kit_*.
 * Guardadas nunca vão.
 */
function cartPayload(state, { kitId, kitName = 'Monte Seu Kit', unitLabel = 'mini', products } = {}) {
  if (typeof kitId !== 'string' || !kitId) throw new TypeError('kitId obrigatório');
  if (products && !canSubmit(state, products)) throw new RangeError('Kit fora das regras (tamanho, disponibilidade ou teto)');
  if (!products && state.units.length !== state.size) throw new RangeError('Kit incompleto');
  if (state.units.some((u) => !/^\d+$/.test(u.variantId))) throw new RangeError('Unidade sem variante comercial (prévia)');
  const order = [];
  const qty = new Map();
  for (const u of state.units) {
    if (!qty.has(u.variantId)) order.push(u.variantId);
    qty.set(u.variantId, (qty.get(u.variantId) || 0) + 1);
  }
  const total = state.units.length;
  return order.map((id) => ({
    id: Number(id),
    quantity: qty.get(id),
    properties: {
      _kit_id: kitId,
      _kit_size: String(total),
      _kit_name: kitName,
      _kit_unit_label: unitLabel,
    },
  }));
}

/** Serialização: sem preços, sem nomes; só ordem + identidade + tamanho + guardadas. */
function serialize(state, now = Date.now()) {
  return JSON.stringify({
    v: STORAGE_VERSION,
    exp: now + TTL_MS,
    size: state.size,
    units: state.units.map((u) => [u.instanceId, u.variantId]),
    stash: state.stash.map((u) => [u.instanceId, u.variantId]),
  });
}

/**
 * Restaura só o que ainda é válido HOJE segundo o catálogo lido do DOM:
 * variante presente e disponível, teto por mini (kit + guardadas), teto total = maior tamanho habilitado.
 * Guardadas só existem se houver caixa maior habilitada; com a flag só '6', são descartadas.
 */
function restore(raw, { sizes = [6], products, now = Date.now(), newId }) {
  const base = createKitState({ sizes });
  let parsed;
  try { parsed = JSON.parse(raw); } catch { return { state: base, dropped: 0, valid: false }; }
  if (!parsed || parsed.v !== STORAGE_VERSION || !(parsed.exp > now) || !Array.isArray(parsed.units)) {
    return { state: base, dropped: 0, valid: false };
  }
  const shell = createKitState({ sizes: base.sizes, size: parsed.size });
  const max = Math.max(...shell.sizes);
  const seen = new Set();
  const counts = new Map();
  let dropped = 0;
  const take = (list) => {
    const out = [];
    for (const entry of Array.isArray(list) ? list : []) {
      const [rawId, rawVariant] = Array.isArray(entry) ? entry : [];
      const variantId = String(rawVariant ?? '');
      const p = products.get(variantId);
      const c = counts.get(variantId) || 0;
      if (!p || !p.available || c >= capOf(p) || seen.size >= max) { dropped += 1; continue; }
      let instanceId = typeof rawId === 'string' && rawId && !seen.has(rawId) ? rawId : newId();
      while (seen.has(instanceId)) instanceId = newId();
      seen.add(instanceId);
      counts.set(variantId, c + 1);
      out.push({ instanceId, variantId });
    }
    return out;
  };
  // Estrutura preservada: guardadas nunca "sobem" para o kit ativo ao restaurar (o kit pode ter < 6 com guardadas).
  const active = take(parsed.units);
  const kept = take(parsed.stash);
  const units = active.slice(0, shell.size);
  let stash = [...active.slice(shell.size), ...kept];
  if (!biggerThan(shell, shell.size)) { dropped += stash.length; stash = []; }
  return { state: make(shell.sizes, shell.size, units, stash), dropped, valid: true };
}

return Object.freeze({ KIT_SIZES, KIT_LABELS, STORAGE_VERSION, STORAGE_PREFIX, LEGACY_STORAGE_KEYS, TTL_MS, parseSizes, storageKey, createKitState, countOf, countAllOf, capOf, addUnit, removeUnit, removeLastOf, clearUnits, setSize, summarize, canSubmit, missingText, fullText, cartPayload, serialize, restore });
})();
// ---- src/submit.mjs
const __m6 = (() => {
// Envio do kit ao carrinho. Sem DOM: recebe fetch injetado (testável com mock).
//
// Garantias:
// - Trava de duplo clique (1 envio em voo por submitter).
// - Só é "sucesso" um 200 cujo corpo traz TODAS as variantes do payload com o _kit_id deste envio.
// - 422 / erro de rede / resposta inválida: reverte linhas parciais DESTE _kit_id (nunca toca em outras
//   linhas do carrinho) e devolve erro; a seleção do builder é preservada pelo chamador.
const { cartPayload } = __m5;

const SUBMIT_ERRORS = Object.freeze({
  busy: 'Estamos adicionando o seu kit. Aguarde um instante.',
  network: 'Sem conexão com a loja. Seu kit continua salvo aqui; tente de novo.',
  rejected: 'Não foi possível adicionar o kit.',
  invalid: 'O carrinho não confirmou o kit completo. Seu kit continua salvo aqui; tente de novo.',
});

const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

function createKitSubmitter({ fetchImpl, root = '/', uuid }) {
  if (typeof fetchImpl !== 'function') throw new TypeError('fetchImpl obrigatório');
  if (typeof uuid !== 'function') throw new TypeError('uuid obrigatório');
  let inFlight = false;

  async function getCart() {
    const r = await fetchImpl(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!r.ok) throw new Error(`cart.js HTTP ${r.status}`);
    return r.json();
  }

  async function rollback(kitId) {
    try {
      const cart = await getCart();
      const updates = {};
      for (const it of cart.items || []) if (it?.properties?._kit_id === kitId) updates[it.key] = 0;
      if (!Object.keys(updates).length) return { attempted: false, ok: true };
      const r = await fetchImpl(`${root}cart/update.js`, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ updates }) });
      return { attempted: true, ok: r.ok };
    } catch {
      return { attempted: true, ok: false };
    }
  }

  function confirms(json, items, kitId) {
    const lines = Array.isArray(json?.items) ? json.items : [];
    return items.every((expected) => lines.some((l) => Number(l?.variant_id ?? l?.id) === expected.id && l?.properties?._kit_id === kitId));
  }

  async function submit(state, { products, kitName, unitLabel, sections = [] } = {}) {
    if (inFlight) return { ok: false, code: 'busy', message: SUBMIT_ERRORS.busy };
    inFlight = true;
    const kitId = uuid();
    try {
      const items = cartPayload(state, { kitId, kitName, unitLabel, products });
      let res;
      let json = {};
      try {
        res = await fetchImpl(`${root}cart/add.js`, {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items, sections: sections.join(','), sections_url: `${root}cart` }),
        });
        json = await res.json().catch(() => ({}));
      } catch {
        const rb = await rollback(kitId);
        return { ok: false, code: 'network', message: SUBMIT_ERRORS.network, kitId, rollback: rb };
      }
      if (!res.ok) {
        const rb = await rollback(kitId);
        const detail = json?.description || json?.message;
        return { ok: false, code: 'rejected', status: res.status, message: detail ? `${SUBMIT_ERRORS.rejected} ${detail}` : SUBMIT_ERRORS.rejected, kitId, rollback: rb };
      }
      if (!confirms(json, items, kitId)) {
        const rb = await rollback(kitId);
        return { ok: false, code: 'invalid', message: SUBMIT_ERRORS.invalid, kitId, rollback: rb };
      }
      let cart = null;
      try { cart = await getCart(); } catch { cart = null; }
      if (cart) cart.sections = json.sections || {};
      return { ok: true, kitId, items, cart, sections: json.sections || {} };
    } finally {
      inFlight = false;
    }
  }

  return Object.freeze({ submit, isBusy: () => inFlight });
}

return Object.freeze({ SUBMIT_ERRORS, createKitSubmitter });
})();
// ---- src/visual-map.mjs
const __m7 = (() => {
// Mapeamento EXPLÍCITO: SKU da variante do produto AVULSO no Shopify -> SKU visual do catálogo Codex.
//
// Cadeia completa (nenhum elo é deduzido):
//   card do builder (Liquid) = pick da coleção do kit (variant id da pick, preço, estoque)
//     -> metafield kit.avulso_product -> variante do avulso -> sku do avulso (Liquid)
//     -> ESTA TABELA -> sku visual (catalog-data.mjs do Codex) -> artes SVG.
//
// Regras:
// - Chaves copiadas LITERALMENTE do Shopify (read-only, 25/09/2026, productVariants sku:*5ML*).
//   Atenção às duas grafias fora do padrão: "DOUCEUR DE LITCHI-5ML" (com espaço) e "DOUCEURDENECTAR-5ML".
// - Lookup exato. Nada de normalizar (trim, upper, trocar espaço por hífen, cortar sufixo -K6).
//   SKU ausente da tabela => null => cartucho neutro no SVG. A compra NÃO depende disso.
// - IDs Tiny não são IDs Shopify e não entram aqui. Variant ids vêm só do Liquid.
// - Preço, disponibilidade e estoque NÃO vêm daqui (só do Liquid).
const VISUAL_SKU_BY_AVULSO_SKU = Object.freeze({
  'SOUFFLE-DE-MATCHA-5ML': 'SOUFFLE-DE-MATCHA-5ML',
  'BRISE-DE-FREESIA-5ML': 'BRISE-DE-FREESIA-5ML',
  'DOUCEUR DE LITCHI-5ML': 'DOUCEUR-DE-LITCHI-5ML',
  'BRISE-DE-BERGAMOTE-5ML': 'BRISE-DE-BERGAMOTE-5ML',
  'BRISE-DE-LIMA-5ML': 'BRISE-DE-LIMA-5ML',
  'BRISE-DE-MURES-5ML': 'BRISE-DE-MURES-5ML',
  'BRUME-DE-BAIN-5ML': 'BRUME-DE-BAIN-5ML',
  'BRUME-DE-PATCHOULI-5ML': 'BRUME-DE-PATCHOULI-5ML',
  'DOUCEURDENECTAR-5ML': 'DOUCEUR-DE-NECTAR-5ML',
  'SOUFFLE-DE-SANTAL-5ML': 'SOUFFLE-DE-SANTAL-5ML',
  'SORBET-GINGEMBRE-5ML': 'SORBET-GINGEMBRE-5ML',
  'SORBET-MELON-5ML': 'SORBET-MELON-5ML',
  'SORBET-CAMOMILLE-ANANAS-5ML': 'SORBET-CAMOMILLE-ANANAS-5ML',
  'SORBET-CONCOMBRE-SEL-5ML': 'SORBET-CONCOMBRE-SEL-5ML',
  'BRUME-DE-BAIN-VERTE-5ML': 'BRUME-DE-BAIN-VERTE-5ML',
  'LINGE-DE-BEBE-5ML': 'LINGE-DE-BEBE-5ML',
  'LINGE-AU-SOLEIL-5ML': 'LINGE-AU-SOLEIL-5ML',
  'BAIN-DE-LINGE-5ML': 'BAIN-DE-LINGE-5ML',
  'LINGE-A-LA-VAPEUR-5ML': 'LINGE-A-LA-VAPEUR-5ML',
  'LINGE-LAVE-5ML': 'LINGE-LAVE-5ML',
  'LINGE-DE-CACHEMIRE-5ML': 'LINGE-DE-CACHEMIRE-5ML',
});

function visualSkuForAvulso(avulsoSku) {
  if (typeof avulsoSku !== 'string') return null;
  return Object.prototype.hasOwnProperty.call(VISUAL_SKU_BY_AVULSO_SKU, avulsoSku)
    ? VISUAL_SKU_BY_AVULSO_SKU[avulsoSku]
    : null;
}

return Object.freeze({ VISUAL_SKU_BY_AVULSO_SKU, visualSkuForAvulso });
})();
// ---- src/timing.mjs
const __m8 = (() => {
// Tempos do builder, amarrados ao renderer do Codex (vendor/codex-svg/component/renderer.mjs).
// O teste test/timing.test.mjs falha se o renderer ou o CSS divergirem destes valores.

// Fechamento da tampa no renderer: duration = 1150 * |Δprogresso| e easing smoothstep t²(3−2t).
// smoothstep é EXATAMENTE a cúbica de Bézier com controles (1/3, 0) e (2/3, 1): x(t) = t, y(t) = 3t² − 2t³.
const LID_CLOSE_MS = 1150;
const LID_EASING_CSS = 'cubic-bezier(0.3333, 0, 0.6667, 1)';

// Espera entre completar o kit e a tampa começar a fechar (deixa o último cartucho entrar; 280 ms no renderer).
// O botão CONFIRMAR/Adicionar começa a "encher" no mesmo instante e dura LID_CLOSE_MS.
const LID_AUTO_CLOSE_MS = 650;

// Dicas temporárias ("Faltam N minis", aviso de prévia): somem sozinhas.
const HINT_MS = 3000;
const HINT_FADE_MS = 300;

const smoothstep = (t) => t * t * (3 - 2 * t);

return Object.freeze({ LID_CLOSE_MS, LID_EASING_CSS, LID_AUTO_CLOSE_MS, HINT_MS, HINT_FADE_MS, smoothstep });
})();
// ---- src/preload.mjs
const __m9 = (() => {
// Pré-carregamento + DECODIFICAÇÃO das artes (img.decode()), com deduplicação por URL.
// O renderer usa as mesmas URLs (asset_url versionado => cache longo do CDN e cache de memória do navegador),
// então a face já decodificada aparece no mesmo frame em que o cartucho entra na caixa.
const ADD_WAIT_MS = 280; // espera máxima da entrada do mini pela arte (a ação comercial nunca espera)

function createPreloader({ ImageCtor = globalThis.Image, now = () => performance.now() } = {}) {
  const cache = new Map(); // url -> { promise, done, ok, img, t0, t1 }

  function load(url) {
    if (typeof url !== 'string' || !url) return Promise.resolve(false);
    const hit = cache.get(url);
    if (hit) return hit.promise;
    const e = { done: false, ok: false, t0: now(), t1: null };
    const img = new ImageCtor();
    img.decoding = 'async';
    img.src = url;
    e.img = img; // mantém a referência: o navegador preserva a imagem decodificada
    const decode = typeof img.decode === 'function'
      ? img.decode()
      : new Promise((res, rej) => { img.onload = res; img.onerror = rej; });
    e.promise = decode.then(() => { e.done = true; e.ok = true; e.t1 = now(); return true; }, () => { e.done = true; e.t1 = now(); return false; });
    cache.set(url, e);
    return e.promise;
  }

  const isReady = (url) => !!cache.get(url)?.done;
  const allReady = (urls) => urls.filter(Boolean).every(isReady);

  /** Resolve quando todas decodificarem OU no teto (maxWait). Retorna { ready, waited }. */
  function whenReady(urls, maxWait = ADD_WAIT_MS) {
    const list = urls.filter(Boolean);
    if (allReady(list)) return Promise.resolve({ ready: true, waited: 0 });
    const t0 = now();
    let timer;
    const timeout = new Promise((res) => { timer = setTimeout(() => res(false), maxWait); });
    return Promise.race([Promise.all(list.map(load)).then(() => true), timeout])
      .then((done) => { clearTimeout(timer); return { ready: done === true && allReady(list), waited: now() - t0 }; });
  }

  /** Fila em ociosidade (requestIdleCallback), em lotes pequenos. */
  function idle(urlsList, { requestIdle = globalThis.requestIdleCallback, batch = 3 } = {}) {
    const queue = urlsList.flat().filter((u) => u && !cache.has(u));
    const step = (deadline) => {
      let n = 0;
      while (queue.length && n < batch && (!deadline || deadline.timeRemaining?.() > 4 || deadline.didTimeout)) { load(queue.shift()); n += 1; }
      if (queue.length) schedule();
    };
    const schedule = () => (typeof requestIdle === 'function' ? requestIdle(step, { timeout: 2000 }) : setTimeout(() => step(null), 200));
    if (queue.length) schedule();
    return queue;
  }

  return Object.freeze({ load, isReady, allReady, whenReady, idle, stats: () => ({ total: cache.size, ready: [...cache.values()].filter((e) => e.done).length }) });
}

/** Conexão lenta / economia de dados: só pré-carregar o que está visível (sem fila em ociosidade). */
function isConstrained(nav = globalThis.navigator) {
  const c = nav?.connection;
  return !!(c && (c.saveData || ['slow-2g', '2g', '3g'].includes(c.effectiveType)));
}

return Object.freeze({ ADD_WAIT_MS, createPreloader, isConstrained });
})();
// ---- src/fit.mjs
const __m10 = (() => {
// Encaixe da etapa de conferência SEM rolagem (até 10 minis), do mais confortável ao mais compacto.
// Cada nível é uma densidade da lista (altura da linha / miniatura / colunas). O DOM aplica um nível, mede
// (scrollHeight <= clientHeight do contêiner que rolaria) e, se não couber, passa ao próximo. Só no fim permite rolar.
const REVIEW_LEVELS = Object.freeze([
  { id: 'n', row: 56, thumb: 44, cols: 1 },
  { id: 'c', row: 44, thumb: 36, cols: 1 },
  { id: 't', row: 36, thumb: 28, cols: 1 },
  { id: 'x', row: 30, thumb: 24, cols: 1 },
  { id: 'c2', row: 44, thumb: 32, cols: 2 },
  { id: 't2', row: 36, thumb: 26, cols: 2 },
  { id: 'scroll', row: 30, thumb: 24, cols: 2 },
]);

/**
 * apply(level) aplica a densidade; fits() mede se coube. Retorna o 1º nível que coube (ou 'scroll').
 * Sem estado: chamado de novo a cada render/resize da conferência.
 */
function fitReview(apply, fits, levels = REVIEW_LEVELS) {
  for (const level of levels) {
    apply(level);
    if (level.id === 'scroll' || fits()) return level;
  }
  return levels[levels.length - 1];
}

/** Estimativa pura (para testes e para começar perto do nível certo): altura necessária da lista. */
function listHeight(level, n) {
  return Math.ceil(n / level.cols) * level.row;
}

return Object.freeze({ REVIEW_LEVELS, fitReview, listHeight });
})();
// ---- src/box.mjs
const __m11 = (() => {
// Rodada 8: o que um toque na caixa faz, em função do kit e da tampa (puro; testado em test/box.test.mjs).
//   'closed'        kit completo, tampa fechada/fechando  -> toque ABRE (não remove); a caixa é o botão "Abrir caixa para editar"
//   'open-complete' kit completo, tampa aberta            -> toque numa caixinha REMOVE; fora delas FECHA; há alvo "Fechar caixa"
//   'editing'       kit incompleto                         -> toque numa caixinha REMOVE
//   'busy'          enviando ou tampa abrindo              -> ignora
//   'none'          sem prévia (arte indisponível)         -> ignora
function boxModeOf({ hasPreview, broken = false, busy = false, total, size, lidPhase }) {
  if (!hasPreview || broken) return 'none';
  if (busy) return 'busy';
  if (total !== size) return 'editing';
  if (lidPhase === 'open') return 'open-complete';
  return lidPhase === 'opening' ? 'busy' : 'closed';
}

/** Ação do toque: 'open' | 'close' | 'remove' | null. */
function boxTapAction(mode, onCarton) {
  if (mode === 'closed') return 'open';
  if (mode === 'open-complete') return onCarton ? 'remove' : 'close';
  if (mode === 'editing') return onCarton ? 'remove' : null;
  return null;
}

const cartonsRemovable = (mode) => mode === 'editing' || mode === 'open-complete';

return Object.freeze({ boxModeOf, boxTapAction, cartonsRemovable });
})();
// ---- src/title.mjs
const __m12 = (() => {
// Título de EXIBIÇÃO sem o texto de releitura/autoral (rodada 9; autoral em 28/09). Espelho de snippets/msk-clean-title.liquid.
// "BRISE DE BERGAMOTE 5ml - RELEITURA BERGAMOTE 22" -> "BRISE DE BERGAMOTE 5ml". Não altera o produto.
const TRAILING = /[\s\-–—|:(,]+$/u;

function cleanTitle(title) {
  const raw = String(title ?? '').trim();
  const low = raw.toLowerCase();
  const at = [low.indexOf('releitura'), low.indexOf('autoral')].filter((i) => i >= 0).sort((a, b) => a - b)[0] ?? -1;
  if (at < 0) return raw;
  const clean = raw.slice(0, at).replace(TRAILING, '').trim();
  return clean || raw;
}

return Object.freeze({ cleanTitle });
})();
// ---- src/element.mjs
// <monte-seu-kit> v3 — camada DOM sobre o markup ATUAL do tema (cards kit-mini-card, painel kit-cesta,
// sticky bar e <x-popover> do tema no mobile). Estado único em ./state.mjs; a prévia SVG (Codex) só recebe
// setKit(); o carrinho só recebe o payload de ./state.mjs via ./submit.mjs.
const { createKitSvgPreview } = __m1;
const { createVisualCatalog, createBoxAssets } = __m4;
const S = __m5;
const { createKitSubmitter } = __m6;
const { visualSkuForAvulso } = __m7;
const { LID_CLOSE_MS, LID_AUTO_CLOSE_MS, HINT_MS, HINT_FADE_MS } = __m8;
const { createPreloader, isConstrained, ADD_WAIT_MS } = __m9;
const { fitReview } = __m10;
const { boxModeOf, boxTapAction, cartonsRemovable } = __m11;
const { cleanTitle } = __m12;

const fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const money = (cents) => fmt.format((Number(cents) || 0) / 100);
const DESKTOP = '(min-width: 1000px)';
const REDUCED = '(prefers-reduced-motion: reduce)';
const PREVIEW_NOTICE = 'Prévia: minis ainda não liberados para venda no kit.';

function uuid() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  const b = new Uint8Array(16);
  globalThis.crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
const storage = {
  get(k) { try { return globalThis.localStorage?.getItem(k) ?? null; } catch { return null; } },
  set(k, v) { try { globalThis.localStorage?.setItem(k, v); } catch { /* sem storage: segue sem persistir */ } },
  del(k) { try { globalThis.localStorage?.removeItem(k); } catch { /* idem */ } },
};
const plural = (n, unit) => `${n} ${n === 1 ? unit : `${unit}s`}`;
const X_ICON = '<svg aria-hidden="true" focusable="false" width="8" height="8" viewBox="0 0 16 16" fill="none"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';

class MonteSeuKit extends HTMLElement {
  connectedCallback() {
    if (this._alive) return;
    this._alive = true;
    this._ac = new AbortController();
    this._timers = new Set();
    this._artIssues = new Set();
    this._lidPhase = 'open';
    this._autoClosedFor = null;
    this._armed = undefined; // (1º render grava data-kit-ready=false) visual "pronto" dos botões (arma junto com a tampa); aria-disabled muda na hora
    this.step = 'box'; // 'box' (caixa) | 'review' (conferência). Não persiste: reload volta para a caixa.

    this.sizes = S.parseSizes(this.dataset.sizes || '6');
    this.kitLabel = this.dataset.kitLabel || 'Monte Seu Kit';
    this.unit = this.dataset.kitUnitLabel || 'mini';
    this.autoOpenDrawer = this.dataset.autoOpenDrawer !== 'false';
    this.mqDesktop = matchMedia(DESKTOP);
    this.mqReduced = matchMedia(REDUCED);

    this.findDrawer();
    this.readCatalog();
    this.assetUrls = this.readAssetMap();
    // Artes: mesmas URLs (asset_url versionado) usadas pelo renderer => o que foi decodificado aqui aparece na hora.
    this.visualCatalog = createVisualCatalog((file) => this.assetUrls[file]);
    this.boxArt = createBoxAssets((file) => this.assetUrls[file]);
    this.faceBySku = new Map(this.visualCatalog.map((i) => [i.sku, Object.values(i.faces)]));
    this.preloader = createPreloader();
    this._pendingArt = new Set(); // instanceIds cuja entrada na caixa espera a arte (máx. ADD_WAIT_MS)
    this.key = S.storageKey(this.sizes);
    for (const k of S.LEGACY_STORAGE_KEYS) storage.del(k);
    this.state = this.restoreState();
    this.buildStage();

    this.submitter = createKitSubmitter({
      fetchImpl: (...a) => fetch(...a),
      root: globalThis.Shopify?.routes?.root || '/',
      uuid,
    });

    this.bindEvents();
    this.startPreloading();
    this.placeStage();
    this.render();
  }

  disconnectedCallback() {
    this._alive = false;
    this._ac?.abort();
    this._io?.disconnect();
    this._cardIo?.disconnect();
    this._drawerObserver?.disconnect();
    document.documentElement.classList.remove('kit-review-lock');
    for (const t of this._timers) clearTimeout(t);
    for (const f of this._flash?.values() || []) { clearTimeout(f.t1); clearTimeout(f.t2); }
    this._timers.clear();
    this.preview?.destroy();
    this.preview = null;
    this.stageEl?.remove();
  }

  later(fn, ms) {
    const t = setTimeout(() => { this._timers.delete(t); if (this._alive) fn(); }, ms);
    this._timers.add(t);
    return t;
  }

  // O <x-popover> do tema migra para <body> no mobile: consultar os dois "roots".
  findDrawer() {
    this.drawer = this.querySelector('[data-kit-drawer]');
    if (!this.drawer) {
      const id = this.querySelector('[data-kit-open-drawer][aria-controls]')?.getAttribute('aria-controls');
      if (id) this.drawer = document.getElementById(id);
    }
    if (this.drawer) {
      // Mantém o comportamento atual: clicar nos cards com o drawer aberto não o fecha.
      this.drawer.hideForOutsideClickTarget = () => false;
      this.drawer.allowOutsideClickForTarget = () => true;
      // O Popover do tema trava a página (html.lock) no mobile, mas este drawer não tem overlay e deixa o
      // catálogo tocável atrás => página "sem scroll". Na etapa caixa o sheet é compacto e NÃO modal: sem trava.
      // A conferência (tela cheia) usa trava própria (html.kit-review-lock), sem mexer no contador global do tema.
      // shouldLock fica SEMPRE false nesta instância (lido na abertura e no fechamento: precisa ser constante).
      Object.defineProperty(this.drawer, 'shouldLock', { configurable: true, get: () => false });
      this.drawer.dataset.step = 'box';
    }
  }
  roots() { return this.drawer && !this.contains(this.drawer) ? [this, this.drawer] : [this]; }
  qa(sel) { return this.roots().flatMap((r) => [...r.querySelectorAll(sel)]); }

  // ---------------------------------------------------------------- dados (só do Liquid)
  readCatalog() {
    this.products = new Map();
    this.cards = new Map();
    for (const card of this.querySelectorAll('[data-kit-card]')) {
      const key = card.dataset.key || card.dataset.variantId;
      if (!key || this.products.has(key)) continue;
      const int = (v) => parseInt(v, 10) || 0;
      const preview = card.dataset.preview === 'true';
      this.products.set(key, Object.freeze({
        available: card.dataset.available ? card.dataset.available === 'true' : card.dataset.outOfStock !== 'true',
        commercial: !preview,
        cap: card.dataset.cap ? int(card.dataset.cap) : 10,
        kitPrice: preview ? 0 : int(card.dataset.kitPrice),
        avulsoPrice: preview ? 0 : int(card.dataset.avulsoPrice),
        title: cleanTitle(card.dataset.productTitle),
        shortTitle: cleanTitle(card.dataset.shortTitle || card.dataset.productTitle),
        image: card.dataset.imageUrl || '',
        url: card.dataset.url || '',
        visualSku: visualSkuForAvulso(card.dataset.avulsoSku),
      }));
      this.cards.set(key, card);
    }
  }

  readAssetMap() {
    try { return JSON.parse(this.querySelector('[data-msk-assets]')?.textContent || '{}'); } catch { return {}; }
  }

  restoreState() {
    const def = parseInt(this.dataset.defaultSize, 10);
    const raw = storage.get(this.key);
    if (raw) {
      const r = S.restore(raw, { sizes: this.sizes, products: this.products, newId: uuid });
      if (r.valid) return r.state;
      storage.del(this.key);
    }
    return S.createKitState({ sizes: this.sizes, size: def });
  }

  persist() {
    if (this.state.units.length === 0) storage.del(this.key);
    else storage.set(this.key, S.serialize(this.state));
  }

  // ---------------------------------------------------------------- caixa (prévia SVG)
  buildStage() {
    this.stageEl = document.createElement('div');
    this.stageEl.className = 'kit-stage';
    // Contêiner da caixa. Kit completo: role=button (abre/fecha a tampa). Incompleto: sem papel próprio; cada caixinha
    // vira um alvo focável que remove aquela unidade (não dá para aninhar alvos dentro de um <button>).
    this.boxBtn = document.createElement('div');
    this.boxBtn.className = 'kit-stage__box';
    this.boxBtn.setAttribute('aria-disabled', 'true');
    this.boxMount = document.createElement('div');
    this.boxMount.className = 'kit-stage__art';
    this.boxBtn.append(this.boxMount);
    this.stageNote = document.createElement('p');
    this.stageNote.className = 'kit-stage__note text-xs';
    this.stageNote.hidden = true;
    this.closeBoxBtn = document.createElement('button');
    this.closeBoxBtn.type = 'button';
    this.closeBoxBtn.className = 'kit-stage__close';
    this.closeBoxBtn.textContent = 'Fechar caixa';
    this.closeBoxBtn.hidden = true;
    this.stageEl.append(this.boxBtn, this.closeBoxBtn, this.stageNote);
  }

  placeStage() {
    const variant = this.mqDesktop.matches ? 'panel' : 'drawer';
    const slot = this.qa(`[data-kit-cesta][data-variant="${variant}"] [data-kit-stage-slot]`)[0];
    if (slot && this.stageEl.parentElement !== slot) slot.append(this.stageEl);
    if (variant === 'panel' || this.drawer?.hasAttribute('open')) this.ensurePreview();
  }

  ensurePreview() {
    if (this.preview || !this._alive) return;
    const resolve = (file) => this.assetUrls[file];
    try {
      this.preview = createKitSvgPreview(this.boxMount, {
        catalog: this.visualCatalog,
        boxAssets: this.boxArt,
        onAssetError: (sku, d) => this.onArtIssue(sku, d, true),
        onAssetResolved: (sku, d) => this.onArtIssue(sku, d, false),
        onLidStateChange: (phase) => this.onLid(phase),
      });
    } catch (err) {
      console.warn('[monte-seu-kit] prévia indisponível', err);
      this.stageEl.dataset.broken = 'true';
      this.showStageNote('A prévia da caixa não carregou. Sua escolha e o carrinho seguem normais.');
      return;
    }
    this.render(); // recalcula estado da caixa (botão abrir/fechar) já com a prévia montada
  }

  syncPreview(sum) {
    if (!this.preview) return;
    const st = this.state;
    // A caixinha só entra quando a arte dela está decodificada (ou o teto estourou). Mantém a ordem: mostra o prefixo
    // até a 1ª unidade pendente. Estado/contagem/botões já foram atualizados (a ação comercial não espera).
    const firstPending = st.units.findIndex((u) => this._pendingArt.has(u.instanceId));
    const shown = firstPending < 0 ? st.units : st.units.slice(0, firstPending);
    sum = { ...sum, complete: sum.complete && shown.length === st.units.length };
    const before = this.slotX();
    try {
      this.preview.setKit({
        kitSize: st.size,
        selections: shown.map((u) => {
          const p = this.products.get(u.variantId);
          return { instanceId: u.instanceId, sku: p?.visualSku || `sem-arte:${u.variantId}`, name: p?.shortTitle || '' };
        }),
      });
    } catch (err) {
      console.warn('[monte-seu-kit] setKit recusado', err);
      return;
    }
    this.updateBoxRoles(before);
    // Fechamento = só transição visual quando o kit fica completo. Não bloqueia nem atrasa o envio.
    const composition = `${st.size}|${shown.map((u) => u.instanceId).join(',')}`;
    if (this._lidTimer) { clearTimeout(this._lidTimer); this._timers.delete(this._lidTimer); this._lidTimer = null; }
    if (!sum.complete) this._autoClosedFor = null; // ficou incompleto (ou com excedentes): ao completar de novo, fecha de novo
    if (sum.complete && this._autoClosedFor !== composition) {
      this._lidTimer = this.later(() => {
        this._lidTimer = null;
        if (!this.preview || this._autoClosedFor === composition) return;
        this._autoClosedFor = composition;
        this.preview.setClosed(true);
      }, this.mqReduced.matches ? 0 : LID_AUTO_CLOSE_MS);
    }
  }

  onLid(phase) {
    this._lidPhase = phase;
    const closed = phase === 'closed' || phase === 'closing';
    this.stageEl.dataset.lid = phase;
    this.updateBoxRoles();
  }

  toggleLid() {
    const mode = this.boxMode();
    if (mode === 'closed') this.setLid(false);
    else if (mode === 'open-complete') this.setLid(true);
  }

  // Toque/Enter na caixa: kit completo => tampa; incompleto => remove a caixinha tocada (identidade por unidade).
  // Rodada 8. Kit completo + tampa fechada: 1º toque ABRE (não remove). Tampa aberta (ou kit incompleto): tocar numa
  // caixinha remove aquela unidade; com o kit completo e aberta, tocar fora das caixinhas fecha a tampa de novo.
  onBoxActivate(e) {
    const g = e.target.closest?.('[data-instance-id]');
    const onCarton = !!g && g.dataset.exiting !== 'true' && this.boxMount.contains(g);
    const action = boxTapAction(this.boxMode(), onCarton);
    if (action === 'open') this.setLid(false);
    else if (action === 'close') this.setLid(true); // toque fora das caixinhas fecha de novo
    else if (action === 'remove') this.removeFromBox(g.dataset.instanceId, e.type === 'keydown');
  }

  /** 'none' (sem prévia) | 'closed' (completo, tampa fechada/fechando) | 'open-complete' | 'editing' (incompleto) | 'busy'. */
  boxMode() {
    const kit = this.preview?.getKit();
    return boxModeOf({ hasPreview: !!this.preview, broken: !!this.stageEl.dataset.broken, busy: !!this.submitter?.isBusy(),
      total: kit ? kit.selections.length : 0, size: kit ? kit.kitSize : -1, lidPhase: this._lidPhase });
  }

  setLid(closed) {
    if (!this.preview) return;
    this._autoClosedFor = `${this.state.size}|${this.state.units.map((u) => u.instanceId).join(',')}`; // gesto manual manda
    const byKeyboard = document.activeElement === this.boxBtn || document.activeElement === this.closeBoxBtn;
    this.preview.setClosed(closed);
    if (byKeyboard) {
      // teclado: ao abrir, foco na 1ª caixinha (removível); ao fechar, foco na caixa (botão "Abrir caixa para editar")
      this.later(() => (closed ? this.boxBtn : this.cartonNodes()[0])?.focus?.({ preventScroll: true }), this.mqReduced.matches ? 0 : 1200);
    }
  }

  // Papéis acessíveis da caixa conforme o modo (chamado em cada render/setKit e em cada fase da tampa).
  updateBoxRoles(before = new Map()) {
    const mode = this.boxMode();
    const b = this.boxBtn;
    b.classList.remove('is-hover-armed'); // qualquer mudança (abrir/fechar/remover/adicionar) desarma o hover até o mouse mexer
    if (mode === 'closed') {
      b.setAttribute('role', 'button'); b.tabIndex = 0; b.setAttribute('aria-label', 'Abrir caixa para editar');
    } else {
      b.removeAttribute('role'); b.removeAttribute('aria-label'); b.removeAttribute('tabindex');
    }
    b.removeAttribute('aria-pressed');
    b.setAttribute('aria-disabled', String(mode === 'none'));
    b.dataset.mode = mode;
    this.closeBoxBtn.hidden = mode !== 'open-complete';
    this.decorateCartons(before, cartonsRemovable(mode));
  }

  removeFromBox(instanceId, keyboard = false) {
    const idx = this.state.units.findIndex((u) => u.instanceId === instanceId);
    if (idx < 0) return;
    const name = this.products.get(this.state.units[idx].variantId)?.shortTitle || this.unit;
    this.commit(S.removeUnit(this.state, instanceId), `${name} removido.`);
    if (keyboard) {
      const left = this.cartonNodes();
      (left[Math.min(idx, left.length - 1)] || this.boxBtn)?.focus?.({ preventScroll: true });
    }
  }

  cartonNodes() {
    return [...this.boxMount.querySelectorAll('[data-layer="cartons"] [data-instance-id]')].filter((g) => g.dataset.exiting !== 'true');
  }

  slotX() {
    const m = new Map();
    for (const g of this.cartonNodes()) { const x = parseFloat((g.getAttribute('transform') || '').replace(/^translate\(/, '')); if (Number.isFinite(x)) m.set(g.dataset.instanceId, x); }
    return m;
  }

  // Depois de cada setKit: caixinhas removíveis (kit incompleto) viram alvos acessíveis; as que mudaram de posição
  // escorregam para o novo lugar (FLIP) com o easing de entrada do renderer — ao remover, a que sai sobe e some
  // (animação do próprio renderer) e as demais se reacomodam. Movimento reduzido: sem animação.
  decorateCartons(before, removable) {
    const svg = this.boxMount.querySelector('svg');
    if (!svg) return;
    svg.setAttribute('role', removable ? 'group' : 'img');
    this.boxBtn.classList.toggle('is-removable', removable);
    const nameOf = new Map(this.state.units.map((u) => [u.instanceId, this.products.get(u.variantId)?.shortTitle || this.unit]));
    this.cartonNodes().forEach((g, i) => {
      if (removable) {
        g.setAttribute('tabindex', '0');
        g.setAttribute('role', 'button');
        g.setAttribute('aria-label', `Remover ${nameOf.get(g.dataset.instanceId) || this.unit}, posição ${i + 1}`);
      } else {
        g.removeAttribute('tabindex'); g.removeAttribute('role'); g.removeAttribute('aria-label');
      }
      const old = before.get(g.dataset.instanceId);
      const now = parseFloat((g.getAttribute('transform') || '').replace(/^translate\(/, ''));
      const motion = g.querySelector('[data-motion]');
      if (old != null && Number.isFinite(now) && Math.abs(old - now) > 0.5 && !this.mqReduced.matches && motion?.animate) {
        motion.animate([{ transform: `translateX(${old - now}px)` }, { transform: 'translateX(0)' }], { duration: 240, easing: 'cubic-bezier(.2,.7,.3,1)' });
      }
    });
  }

  // ---------------------------------------------------------------- conferência sem rolagem
  syncInnerHeight() {
    // Chrome iOS: a barra de URL é overlay; 100dvh não bate com o visível. Mede com JS.
    const h = Math.round(window.visualViewport?.height || window.innerHeight);
    this.drawer?.style.setProperty('--kit-inner-h', `${h}px`);
  }

  fitReviewLayout() {
    if (this.step !== 'review') return;
    const desktop = this.mqDesktop.matches;
    const cesta = this.visibleCesta();
    const list = cesta?.querySelector('[data-kit-items]');
    const scroller = desktop ? this.querySelector('.monte-seu-kit__panel') : this.drawer?.shadowRoot?.querySelector('[part="content"]');
    if (!list || !scroller || (!desktop && !this.drawer.hasAttribute('open'))) return;
    const level = fitReview((l) => { list.dataset.density = l.id; }, () => scroller.scrollHeight <= scroller.clientHeight + 1);
    this.dataset.reviewDensity = level.id;
  }

  onArtIssue(sku, detail, failed) {
    if (detail?.reason === 'unavailable') return; // arte != estoque; nunca confundir
    const key = `${sku}|${detail?.face || ''}`;
    if (failed) this._artIssues.add(key); else this._artIssues.delete(key);
    this.showStageNote(this._artIssues.size ? 'Algumas artes da caixa não carregaram. Sua escolha e o carrinho seguem normais.' : '');
  }

  showStageNote(text) {
    this.stageNote.textContent = text;
    this.stageNote.hidden = !text;
  }

  // ---------------------------------------------------------------- eventos
  bindEvents() {
    const signal = this._ac.signal;
    // Delegação no <monte-seu-kit> e no drawer (que pode migrar para <body> a qualquer momento).
    // Eventos de dentro do drawer são tratados só pelo listener do drawer (sem duplicar).
    const inDrawer = (e) => !!this.drawer && this.drawer.contains(e.target);
    this.addEventListener('click', (e) => { if (!inDrawer(e)) this.onClick(e); }, { signal });
    this.addEventListener('keydown', (e) => { if (!inDrawer(e)) this.onTabKey(e); }, { signal });
    this.drawer?.addEventListener('click', (e) => this.onClick(e), { signal });
    this.drawer?.addEventListener('keydown', (e) => this.onTabKey(e), { signal });
    // Stepper do tema (quantity-selector): interceptado na captura para o estado ser a única fonte.
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-kit-qty-control] button');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const card = btn.closest('[data-kit-card]');
      const first = btn === btn.parentElement.querySelector('button');
      if (first) this.removeOne(card.dataset.key, btn); else this.add(card.dataset.key, btn);
    }, { capture: true, signal });

    this.boxBtn.addEventListener('click', (e) => this.onBoxActivate(e), { signal });
    this.closeBoxBtn.addEventListener('click', () => this.setLid(true), { signal });
    // Hover "armado" só por movimento real do mouse (pointermove de tipo mouse) depois da última mudança da caixa.
    this.boxBtn.addEventListener('pointermove', (e) => { if (e.pointerType === 'mouse') this.boxBtn.classList.add('is-hover-armed'); }, { signal, passive: true });
    this.boxBtn.addEventListener('pointerleave', () => this.boxBtn.classList.remove('is-hover-armed'), { signal, passive: true });
    this.boxBtn.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.onBoxActivate(e); } }, { signal });
    const onResize = () => { this.syncInnerHeight(); if (this.step === 'review') this.fitReviewLayout(); };
    window.addEventListener('resize', onResize, { signal });
    window.visualViewport?.addEventListener('resize', onResize, { signal });


    this.mqDesktop.addEventListener('change', () => this.placeStage(), { signal });

    if (this.drawer) {
      this._drawerObserver = new MutationObserver(() => {
        if (this.drawer.hasAttribute('open')) { this.placeStage(); this.ensurePreview(); this.syncInnerHeight(); requestAnimationFrame(() => this.fitReviewLayout()); }
        else if (!this.mqDesktop.matches && this.step === 'review') this.goStep('box'); // reabrir por "Ver kit" começa na caixa
        this.syncLock();
      });
      this._drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
    }

    this._inView = true;
    this._io = new IntersectionObserver((entries) => { this._inView = entries[0]?.isIntersecting ?? false; this.renderBar(); });
    this._io.observe(this);
  }

  onClick(e) {
    const t = e.target.closest('button, a, [data-kit-image-add]');
    if (!t) return;
    const card = t.closest('[data-kit-card]');
    if (t.matches('[data-kit-add]') && card) return this.add(card.dataset.key, t);
    if (t.matches('[data-kit-image-add]') && card) return this.add(card.dataset.key, null, { quiet: true });
    if (t.matches('[data-kit-remove]')) return this.removeInstance(t.dataset.kitRemove, t);
    if (t.matches('[role="tab"]')) return this.selectSize(t.dataset.size, t);
    if (t.matches('[data-kit-confirm]')) return this.confirm(t);
    if (t.matches('[data-kit-back]')) return this.goStep('box', { focus: 'confirm' });
    if (t.matches('[data-kit-submit]')) return this.submit(t);
    return undefined;
  }

  onTabKey(e) {
    const tab = e.target.closest?.('[role="tab"]');
    if (!tab) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    const i = tabs.indexOf(tab);
    const next = { ArrowRight: tabs[(i + 1) % tabs.length], ArrowDown: tabs[(i + 1) % tabs.length], ArrowLeft: tabs[(i - 1 + tabs.length) % tabs.length], ArrowUp: tabs[(i - 1 + tabs.length) % tabs.length], Home: tabs[0], End: tabs[tabs.length - 1] }[e.key];
    if (!next) return;
    e.preventDefault();
    this.selectSize(next.dataset.size, next);
    next.focus();
  }

  // ---------------------------------------------------------------- mutações
  commit(next, announce) {
    if (next === this.state) return false;
    const wasEmpty = this.state.units.length === 0;
    const wasComplete = this.state.units.length === this.state.size;
    this.state = next;
    // Ao COMPLETAR (6 na aba 6, 10 na aba 10, inclusive pela auto-troca 6->10): no mobile, se a sheet estiver fechada,
    // ela sobe sozinha na etapa da caixa para a cliente ver a tampa fechando junto com o botão. Só na borda
    // incompleto->completo (fechar a sheet com o kit completo não a reabre). A sheet sobe em 300 ms e a tampa só começa
    // em LID_AUTO_CLOSE_MS (650 ms): a tampa é vista fechando e a sincronia tampa/botão se mantém. Sem trava de rolagem.
    if (!wasComplete && next.units.length === next.size && !this.mqDesktop.matches && this.drawer && !this.drawer.hasAttribute('open') && typeof this.drawer.show === 'function') {
      if (this.step !== 'box') this.goStep('box');
      this.drawer.show(!this.mqReduced.matches); // movimento reduzido: abre sem animação (e a tampa fecha na hora)
      this.placeStage();
      this.ensurePreview();
    }
    this.clearFeedback();
    this.persist();
    this.render();
    if (announce) {
      const sum = S.summarize(this.state, this.products);
      this.announce(`${announce} ${sum.total} de ${this.state.size}.`);
    }
    if (wasEmpty && next.units.length === 1 && this.autoOpenDrawer && !this.mqDesktop.matches && typeof this.drawer?.show === 'function') {
      this.drawer.show(); // comportamento atual do tema: abre só na 1ª adição (setting do editor)
    }
    return true;
  }

  add(key, trigger, { quiet = false } = {}) {
    const r = S.addUnit(this.state, key, this.products, uuid);
    const p = this.products.get(String(key));
    if (!r.ok) {
      if (!quiet && r.reason === 'full') this.announce(`${S.fullText(r.fullSize)}.`);
      if (!quiet && r.reason === 'cap') this.announce(`Não há mais unidades de ${p?.shortTitle} disponíveis para o kit.`);
      return;
    }
    // AUTO 10: kit de 6 cheio + 1 => troca para 10 (com as guardadas de volta) e aceita a adição.
    const msg = r.switchedTo ? `${p?.shortTitle} adicionado. Kit trocado para ${r.switchedTo} ${this.unit}s.` : `${p?.shortTitle} adicionado.`;
    const unit = r.state.units[r.state.units.length - 1];
    const urls = this.faceUrls(key);
    if (this.preview && urls.length && !this.preloader.allReady(urls)) {
      this._pendingArt.add(unit.instanceId);
      this.preloader.whenReady(urls, ADD_WAIT_MS).then(({ ready }) => {
        if (!this._alive || !this._pendingArt.delete(unit.instanceId)) return;
        this.dispatchEvent(new CustomEvent('kit:art', { detail: { instanceId: unit.instanceId, ready } }));
        this.render(); // entra agora; se a arte ainda não chegou, a face faz crossfade quando carregar (CSS)
      });
    }
    this.commit(r.state, msg);
    this.keepCardFocus(key, trigger);
  }

  faceUrls(key) {
    const sku = this.products.get(String(key))?.visualSku;
    return (sku && this.faceBySku.get(sku)) || [];
  }

  // ---------------------------------------------------------------- pré-carregamento das artes
  // 1) tampas K6/K10; 2) minis visíveis (IntersectionObserver); 3) intenção (mouse/toque/foco no card);
  // 4) resto em ociosidade — exceto com Save-Data/conexão lenta (aí só o visível).
  startPreloading() {
    const signal = this._ac.signal;
    for (const b of Object.values(this.boxArt)) this.preloader.load(b.lidExterior);
    for (const u of [...this.state.units, ...this.state.stash]) this.faceUrls(u.variantId).forEach(this.preloader.load);
    const warm = (card) => this.faceUrls(card.dataset.key).forEach(this.preloader.load);
    this._cardIo = new IntersectionObserver((entries) => {
      for (const en of entries) if (en.isIntersecting) { warm(en.target); this._cardIo.unobserve(en.target); }
    }, { rootMargin: '300px 0px' });
    for (const card of this.cards.values()) {
      this._cardIo.observe(card);
      for (const ev of ['pointerenter', 'touchstart', 'focusin']) card.addEventListener(ev, () => warm(card), { signal, passive: true, once: true });
    }
    if (!isConstrained()) {
      const rest = [...this.cards.keys()].map((k) => this.faceUrls(k));
      const start = () => { if (this._alive) this.preloader.idle(rest); };
      if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true, signal });
    }
  }

  removeOne(key, trigger) {
    this.commit(S.removeLastOf(this.state, key), `${this.products.get(String(key))?.shortTitle} removido.`);
    this.keepCardFocus(key, trigger);
  }

  removeInstance(instanceId, trigger) {
    const list = trigger.closest('[data-kit-items]');
    const cesta = trigger.closest('[data-kit-cesta]');
    const idx = [...list.querySelectorAll('[data-kit-remove]')].indexOf(trigger);
    const unit = this.state.units.find((u) => u.instanceId === instanceId);
    // Permanece na conferência: o kit fica incompleto, "Adicionar ao carrinho" desabilita e aparece "Faltam N".
    this.commit(S.removeUnit(this.state, instanceId), `${unit ? this.products.get(unit.variantId)?.shortTitle : ''} removido.`);
    if (!S.canSubmit(this.state, this.products)) this.showHint(this.hintText());
    const after = [...list.querySelectorAll('[data-kit-remove]')];
    (after[Math.min(idx, after.length - 1)] || cesta?.querySelector('[data-kit-back]'))?.focus({ preventScroll: true });
  }

  // ---------------------------------------------------------------- etapas (caixa -> conferência)
  confirm(btn) {
    if (!S.canSubmit(this.state, this.products)) {
      const text = this.hintText();
      this.showHint(text);
      if (btn.closest('[data-kit-sticky-bar]')) this.flashBarHint(text);
      this.announce(text, { force: true });
      return;
    }
    if (btn.closest('[data-kit-sticky-bar]') && typeof this.drawer?.show === 'function') {
      this.goStep('review', { focus: false });
      this.drawer.show();
      this.later(() => this.focusReviewTitle(), 120);
      return;
    }
    this.goStep('review', { focus: 'title' });
  }

  goStep(step, { focus } = {}) {
    const next = step === 'review' && S.canSubmit(this.state, this.products) ? 'review' : 'box';
    const changed = next !== this.step;
    this.step = next;
    for (const cesta of this.qa('[data-kit-cesta]')) {
      cesta.dataset.step = next;
      for (const pane of cesta.querySelectorAll('[data-kit-step]')) {
        const on = pane.dataset.kitStep === next;
        pane.hidden = !on;
        if (on && changed && !this.mqReduced.matches) { pane.classList.remove('is-entering'); void pane.offsetWidth; pane.classList.add('is-entering'); }
      }
      cesta.querySelector('[data-kit-confirm]').hidden = next !== 'box';
      cesta.querySelector('[data-kit-review-actions]').hidden = next !== 'review';
    }
    if (this.drawer) {
      this.drawer.dataset.step = next;
      const head = this.drawer.querySelector('[data-kit-head-box]');
      const title = this.drawer.querySelector('[data-kit-head-review]');
      if (head) head.hidden = next !== 'box';
      if (title) title.hidden = next !== 'review';
    }
    this.syncLock();
    if (changed) { this.hideHint(); this.render(); }
    if (changed) this.announce(next === 'review' ? `Confira seu kit de ${this.state.size} ${this.unit}s.` : 'Caixa do kit.');
    if (focus === 'title') this.focusReviewTitle();
    if (focus === 'confirm') this.visibleCesta()?.querySelector('[data-kit-confirm]')?.focus({ preventScroll: true });
  }

  // Trava da página só com o drawer aberto NA CONFERÊNCIA (tela cheia) no mobile.
  syncLock() {
    const on = !!this.drawer?.hasAttribute('open') && this.step === 'review' && !this.mqDesktop.matches;
    document.documentElement.classList.toggle('kit-review-lock', on);
  }

  visibleCesta() {
    const variant = this.mqDesktop.matches ? 'panel' : 'drawer';
    return this.qa(`[data-kit-cesta][data-variant="${variant}"]`)[0];
  }

  focusReviewTitle() {
    const inDrawer = !this.mqDesktop.matches && this.drawer;
    const el = inDrawer ? this.drawer.querySelector('[data-kit-head-review]') : this.visibleCesta()?.querySelector('[data-kit-review-title]');
    el?.focus({ preventScroll: true });
  }

  hintText() {
    const sum = S.summarize(this.state, this.products);
    return sum.previewCount ? PREVIEW_NOTICE : (S.missingText(this.state, this.unit) || '');
  }

  // Dica temporária: aparece e some sozinha em HINT_MS (fade de HINT_FADE_MS; sem fade com movimento reduzido).
  // Um novo toque reinicia o timer. O anúncio acessível sai pela região aria-live global (uma vez por toque).
  flashTemporary(key, els, text, onHidden) {
    this._flash = this._flash || new Map();
    const prev = this._flash.get(key);
    if (prev) { clearTimeout(prev.t1); clearTimeout(prev.t2); }
    if (!text || !els.length) return;
    for (const el of els) { el.textContent = text; el.hidden = false; el.classList.remove('is-fading'); }
    const done = () => { for (const el of els) { el.hidden = true; el.classList.remove('is-fading'); } onHidden?.(); this._flash.delete(key); };
    const entry = {};
    entry.t1 = setTimeout(() => {
      if (!this._alive) return;
      if (this.mqReduced.matches) { done(); return; }
      for (const el of els) el.classList.add('is-fading');
      entry.t2 = setTimeout(() => { if (this._alive) done(); }, HINT_FADE_MS);
    }, HINT_MS);
    this._flash.set(key, entry);
  }

  hideTemporary(key, els) {
    const prev = this._flash?.get(key);
    if (prev) { clearTimeout(prev.t1); clearTimeout(prev.t2); this._flash.delete(key); }
    for (const el of els) { el.hidden = true; el.classList.remove('is-fading'); }
  }

  showHint(text) { this.flashTemporary('hint', this.qa('[data-kit-hint]'), text); }
  hideHint() { this.hideTemporary('hint', this.qa('[data-kit-hint]')); }

  flashBarHint(text) {
    for (const bar of this.querySelectorAll('[data-kit-sticky-bar]')) {
      const hint = bar.querySelector('[data-kit-bar-hint]');
      const count = bar.querySelector('[data-kit-bar-count]');
      if (!hint) continue;
      if (count) count.hidden = true;
      this.flashTemporary('bar', [hint], text, () => { if (count) count.hidden = false; });
    }
  }

  selectSize(size, trigger) {
    const next = S.setSize(this.state, size);
    if (next === this.state) return;
    this.commit(next, `Kit de ${next.size} ${this.unit}s.`);
    trigger?.focus({ preventScroll: true });
  }

  keepCardFocus(key, trigger) {
    if (!trigger) return;
    if (trigger.isConnected && !trigger.disabled && !trigger.closest('[hidden]')) return;
    const card = this.cards.get(String(key));
    const ctl = card?.querySelector('[data-kit-qty-control]');
    const candidates = ctl && !ctl.hidden ? [...ctl.querySelectorAll('button')].reverse() : [card?.querySelector('[data-kit-add]')];
    candidates.find((el) => el && !el.disabled)?.focus({ preventScroll: true });
  }

  // ---------------------------------------------------------------- render
  render() {
    const st = this.state;
    const sum = S.summarize(st, this.products);
    const ready = S.canSubmit(st, this.products);
    const busy = this.submitter.isBusy();
    const counts = new Map();
    for (const u of st.units) counts.set(u.variantId, (counts.get(u.variantId) || 0) + 1);
    // Caixa ativa cheia sem caixa maior disponível para a troca automática => + bloqueado (com dica).
    const bigger = st.sizes.find((z) => z > st.size);
    const blocked = st.units.length >= st.size && (!bigger || st.units.length + st.stash.length >= bigger);
    if (ready) this.hideHint(); // dica some ao completar

    for (const tab of this.qa('[role="tab"]')) {
      const on = Number(tab.dataset.size) === st.size;
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
    }
    this.dataset.size = String(st.size);

    // Cards
    for (const [key, card] of this.cards) {
      const p = this.products.get(key);
      const q = counts.get(key) || 0;
      card.dataset.qty = String(q);
      const qtyEl = card.querySelector('[data-kit-qty]');
      if (qtyEl && qtyEl.textContent !== String(q)) qtyEl.textContent = String(q);
      const badge = card.querySelector('[data-kit-qty-badge]');
      if (badge) badge.textContent = q ? String(q) : '';
      const add = card.querySelector('[data-kit-add]');
      const ctl = card.querySelector('[data-kit-qty-control]');
      const capped = S.countAllOf(st, key) >= S.capOf(p);
      const why = blocked ? ` (${S.fullText(bigger && st.units.length + st.stash.length >= bigger ? bigger : st.size).toLowerCase()})` : capped ? ' (sem mais unidades para o kit)' : '';
      if (add) {
        add.hidden = q > 0;
        if (p.available) {
          add.disabled = blocked || capped || S.capOf(p) === 0;
          add.setAttribute('aria-label', `Adicionar ${p.shortTitle} ao kit${why}`);
        }
      }
      if (ctl) {
        ctl.hidden = q === 0;
        const [dec, inc] = ctl.querySelectorAll('button');
        if (dec) { dec.disabled = q === 0; dec.setAttribute('aria-label', `Remover um ${p.shortTitle}`); }
        // + só desabilitado quando a caixa não aceita mais (o aria-label explica o motivo).
        if (inc) { inc.disabled = !p.available || blocked || capped; inc.setAttribute('aria-label', `Adicionar mais um ${p.shortTitle}${why}`); }
      }
    }

    // Cestas (painel + drawer)
    for (const cesta of this.qa('[data-kit-cesta]')) {
      this.renderTicks(cesta.querySelector('[data-kit-ticks]'), sum);
      this.renderItems(cesta.querySelector('[data-kit-items]'), st);
      const title = cesta.querySelector('[data-kit-review-title]');
      const label = `Confira seu kit · ${st.size} ${this.unit}s`;
      if (title && title.textContent !== label) title.textContent = label;
      const headTitle = this.drawer?.querySelector('[data-kit-head-review]');
      if (headTitle && headTitle.textContent !== label) headTitle.textContent = label;
      const confirmBtn = cesta.querySelector('[data-kit-confirm]');
      confirmBtn.setAttribute('aria-disabled', String(!ready));
      confirmBtn.hidden = this.step !== 'box';
      cesta.querySelector('[data-kit-review-actions]').hidden = this.step !== 'review';
      cesta.querySelector('[data-kit-hint]').dataset.kind = sum.previewCount ? 'preview' : 'missing';
    }
    this.setAll('[data-kit-counter]', String(sum.total));
    this.setAll('[data-kit-target]', String(st.size));
    this.setAll('[data-kit-total]', sum.previewCount ? '—' : money(sum.kitCents));
    for (const el of this.qa('[data-kit-total-avulso]')) {
      const show = !sum.previewCount && sum.total > 0 && sum.avulsoCents > sum.kitCents;
      el.hidden = !show;
      if (show) el.textContent = money(sum.avulsoCents);
    }
    for (const b of this.querySelectorAll('[data-kit-sticky-bar] [data-kit-confirm]')) b.setAttribute('aria-disabled', String(!ready));
    for (const b of this.qa('[data-kit-submit]')) {
      const enabled = ready && !busy;
      b.setAttribute('aria-disabled', String(!enabled));
      b.disabled = false;
      b.toggleAttribute('aria-busy', busy);
      const label = busy ? 'Adicionando…' : 'Adicionar ao carrinho';
      if (b.textContent.trim() !== label) b.textContent = label;
    }

    this.syncReadyVisual(ready && !busy);

    // Caixa
    // Papéis da caixa: updateBoxRoles() (chamado no syncPreview e a cada fase da tampa).

    this.renderBar();
    this.syncPreview(sum);
    if (this.step === 'review') this.fitReviewLayout();
  }

  setAll(sel, text) { for (const el of this.qa(sel)) if (el.textContent !== text) el.textContent = text; }

  renderTicks(host, sum) {
    if (!host) return;
    const n = sum.size;
    if (host.childElementCount !== n) host.replaceChildren(...Array.from({ length: n }, () => document.createElement('i')));
    [...host.children].forEach((tick, i) => { tick.className = i < sum.total ? 'is-on' : ''; });
  }

  renderItems(ol, st) {
    if (!ol) return;
    const want = st.units.map((u) => u.instanceId);
    const existing = new Map([...ol.children].map((li) => [li.dataset.key, li]));
    for (const [key, li] of existing) if (!want.includes(key)) li.remove();
    want.forEach((key, i) => {
      const li = existing.get(key) || this.makeRow(st.units[i]);
      if (ol.children[i] !== li) ol.insertBefore(li, ol.children[i] || null);
    });
    [...ol.children].forEach((li, i) => {
      const p = this.products.get(li.dataset.variantId);
      li.querySelector('.kit-row__pos').textContent = String(i + 1);
      li.querySelector('[data-kit-remove]').setAttribute('aria-label', `Remover ${p?.shortTitle || this.unit}, posição ${i + 1}`);
    });
  }

  makeRow(unit) {
    const p = this.products.get(unit.variantId) || {};
    const li = document.createElement('li');
    li.className = 'kit-row';
    li.dataset.key = unit.instanceId;
    li.dataset.variantId = unit.variantId;
    const pos = document.createElement('span');
    pos.className = 'kit-row__pos';
    pos.setAttribute('aria-hidden', 'true');
    const img = document.createElement('img');
    img.className = 'kit-row__img';
    img.alt = '';
    img.width = 48; img.height = 48;
    img.loading = 'lazy';
    if (p.image) img.src = p.image;
    const name = document.createElement('span');
    name.className = 'kit-row__name';
    name.textContent = p.shortTitle || unit.variantId;
    const price = document.createElement('span');
    price.className = 'kit-row__price';
    price.textContent = p.commercial === false ? '—' : money(p.kitPrice);
    const rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'kit-row__remove';
    rm.dataset.kitRemove = unit.instanceId;
    rm.innerHTML = X_ICON;
    li.append(pos, img, name, price, rm);
    return li;
  }

  renderBar() {
    const total = this.state.units.length;
    for (const el of this.querySelectorAll('[data-kit-sticky-bar]')) el.classList.toggle('is-visible', total > 0 && this._inView !== false);
  }

  announce(text, { force = false } = {}) {
    const live = this.querySelector('[data-kit-live]');
    if (!live) return;
    clearTimeout(this._liveTimer);
    if (force) live.textContent = ''; // mesmo texto num novo toque: limpa para o leitor anunciar de novo (uma vez)
    this._liveTimer = setTimeout(() => { live.textContent = text; }, 350);
  }

  // ---------------------------------------------------------------- botão sincronizado com a tampa
  // Semântica (aria-disabled) muda na hora: o botão já funciona. O visual "pronto" (data-kit-ready) arma no MESMO
  // instante em que a tampa começa a fechar (LID_AUTO_CLOSE_MS após completar) e dura LID_CLOSE_MS, com a animação
  // nativa de hover do tema (wipe do .button) e o easing da tampa (CSS: .kit-arming). Voltar a incompleto = imediato.
  readyButtons() { return this.qa('[data-kit-confirm], [data-kit-submit]'); }

  syncReadyVisual(ready) {
    if (!ready) {
      if (this._armTimer) { clearTimeout(this._armTimer); this._timers.delete(this._armTimer); this._armTimer = null; }
      if (this._armed || this._armed === undefined) {
        this._armed = false;
        for (const b of this.readyButtons()) { b.classList.remove('kit-arming'); b.dataset.kitReady = 'false'; }
      }
      return;
    }
    if (this._armed || this._armTimer) return;
    if (this._pendingArt?.size) return; // a tampa só começa a fechar quando a última caixinha entra; o botão acompanha
    this._armTimer = this.later(() => { this._armTimer = null; this.armButtons(); }, this.mqReduced.matches ? 0 : LID_AUTO_CLOSE_MS);
  }

  armButtons() {
    this._armed = true;
    const animate = !this.mqReduced.matches;
    for (const b of this.readyButtons()) {
      if (animate) b.classList.add('kit-arming');
      b.dataset.kitReady = 'true';
    }
    this.dispatchEvent(new CustomEvent('kit:armed', { detail: { at: performance.now(), duration: animate ? LID_CLOSE_MS : 0 } }));
    if (animate) this.later(() => { for (const b of this.readyButtons()) b.classList.remove('kit-arming'); }, LID_CLOSE_MS + 60);
  }

  // ---------------------------------------------------------------- carrinho
  clearFeedback() { for (const el of this.qa('[data-kit-feedback]')) el.textContent = ''; }

  async submit(btn) {
    if (this.submitter.isBusy()) return;
    if (!S.canSubmit(this.state, this.products)) {
      const text = this.hintText();
      this.showHint(text);
      this.announce(text, { force: true });
      return;
    }
    this.clearFeedback();
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    const pending = this.submitter.submit(this.state, { products: this.products, kitName: this.kitLabel, unitLabel: this.unit, sections });
    this.render();
    let r;
    try {
      r = await pending;
    } catch (err) {
      console.warn('[monte-seu-kit] envio recusado localmente', err);
      r = { ok: false, code: 'invalid', message: 'Seu kit mudou. Confira a caixa e tente de novo.' };
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
    if (!this._alive) return;
    if (!r.ok) {
      if (r.code === 'busy') return;
      const extra = r.rollback?.attempted && !r.rollback.ok ? ' Confira o carrinho: pode ter entrado parte do kit.' : '';
      this.render();
      for (const el of this.qa('[data-kit-feedback]')) el.textContent = `${r.message}${extra}`;
      return;
    }
    this._autoClosedFor = null;
    this.state = S.clearUnits(this.state);
    this.persist();
    this.goStep('box');
    this.render();
    this.announce('Kit adicionado ao carrinho.');
    if (typeof this.drawer?.hide === 'function' && this.drawer.hasAttribute('open')) this.drawer.hide();
    if (r.cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: r.cart },
      }));
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }
}

if (!customElements.get('monte-seu-kit')) customElements.define('monte-seu-kit', MonteSeuKit);

